
import { AttendanceAdjustResponse, AttendanceLogModel, AttendanceLogResponse, AttendanceModel, AttendanceResponse, DayStatusModel, DeptDataModel, DeptWiseDataModel, EmployeeAttendanceResponse, EmployeeDataModel, EmployeeDataModelResponse, EmployeeShiftAttendanceResponse, EmployeeShiftCountResponse, HolidayDateReq, MonthAttendanceResponse, MonthAttnDataModel, ShiftWiseCountModel, ShiftWiseDataModel, WorkingHrModel } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { AttendanceLogAdapter } from "./dto/attendance-log.adapter";
import { AttendanceLogRequest } from "./dto/attendance-log.request";
import { AttendanceAdapter } from "./dto/attendance.adapter";
import { AttendanceLogEntity } from "./entities/attendance-log.entity";
import { AttendanceLogRepository } from "./repository/attendance-log.repository";
import { AttendanceRepository } from "./repository/attendance.repository";
import { CommonResponse, EmployeeDto } from "@gtpl/shared-models/masters";
import { EmployeeAttendanceRequest } from "./dto/get-emp-attendance.request";
import { ErrorResponse, GlobalResponseObject, LeaveApprovalStatusEnum, UnitRequest } from "@gtpl/shared-models/common-models";
import { AttendanceHelperService } from "./attendance-helper.service";
import { Cron } from '@nestjs/schedule';
import { EmpCodeShiftRequest } from "./dto/emp-code-shift.request";
import { ShiftAttendanceRequest } from "./dto/shift-emp-count.request";
import { AttnCountModel } from "libs/shared-models/hrms/src/lib/attendance/attn-count.model";
import { AttendanceUpdateRequest } from "./dto/attn-update.request";
import { AttendanceEntity } from "./entities/attendance.entity";
import { EmployeeAttDateRequest } from "./dto/empstartdateenddate.request";
import { Between, In, getManager } from "typeorm";
import { AttendanceMonthRequest } from "./dto/month.request";
import { AttendanceAdjustRequest } from "./dto/attendance-adjustment.request";
import { equals } from "class-validator";
import { EmployeeCodesRequest } from "./dto/emp-codes.request";
import { LeaveUpdateRequest } from "./dto/leave-update.request";
import { AttendanceAdjustmentRepository } from "./repository/attendance-adjustment.repository";
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { AttnAdjustLogReq } from "./dto/attn-adjust-log.request";
import { AttendanceAdjustmentAdapter } from "./dto/attn-adjust.adapter";
import { AttendanceAdjustment } from "./entities/attendance-adjustment.entity";
import { OverTimeService } from "@gtpl/shared-services/hrms";
import { UnitcodeService } from "@gtpl/shared-services/masters";
import appSettings from "apps/services/config";
import { DateReq } from "./dto/date.request";
import { HolidaysCalendarService } from '@gtpl/shared-services/hrms'
import { EmployeeDetails } from "apps/services/masters/src/app/employee-details/employee-details.entity";
import { ConsolidatedAttendanceLogRepository } from "./repository/consolidated-attendance-log.repository";
import { ConsolidatedAttendanceLogEntity } from "./entities/consoladate-attendance-logs.entity";
import { DateTime } from 'luxon';
import moment from 'moment-timezone';
import { format } from "url";
import { CartonShortageStatus } from "@gtpl/shared-models/analytics-data";
// Set the default timezone to Asia/Kolkata
moment.tz.setDefault('Asia/Kolkata');

// Now you can use moment with the timezone set


@Injectable()
export class AttendanceService {
    constructor(
        private attendanceLogRepo: AttendanceLogRepository,
        private AttendanceLogAdapter: AttendanceLogAdapter,
        private attendanceRepo: AttendanceRepository,
        private AttendanceAdapter: AttendanceAdapter,
        private attendanceAdjustmentAdapter: AttendanceAdjustmentAdapter,
        private attendanceHelperService: AttendanceHelperService,
        private overTimeService: OverTimeService,
        private unitCodeService: UnitcodeService,
        private consolidatedAttendanceLogRepo: ConsolidatedAttendanceLogRepository,
    ) { }


    async createAttendanceLogs(attnLogReq: AttendanceLogRequest): Promise<AttendanceLogResponse> {
        const convertedAttnLogEntity: AttendanceLogEntity = this.AttendanceLogAdapter.convertDtoToEntity(attnLogReq);
        const savedAttenLogEntity: AttendanceLogEntity = await this.attendanceLogRepo.save(convertedAttnLogEntity);
        const savedAttnLogModel: AttendanceLogModel = this.AttendanceLogAdapter.convertEntityToDto(savedAttenLogEntity);
        if (savedAttnLogModel) {
            await this.insertConsolidatedLog(savedAttenLogEntity);
            const response = new AttendanceLogResponse(true, 11101, ' Logged Successfully', [savedAttnLogModel]);
            return response;
        } else {
            return new AttendanceLogResponse(false, 11106, ' saved but issue while transforming into DTO');
        }
    }

    private determineShift(logTime: any): string {
        console.log(logTime, 'logTimeDate')
        const time = moment(logTime);
        const aShiftStart = time.clone().startOf('day').add(5, 'hours');
        const aShiftEnd = time.clone().startOf('day').add(8, 'hours');

        const gShiftStart = time.clone().startOf('day').add(8, 'hours');
        const gShiftEnd = time.clone().startOf('day').add(13, 'hours');

        const bShiftStart = time.clone().startOf('day').add(13, 'hours');
        const bShiftEnd = time.clone().startOf('day').add(17, 'hours');

        const dShiftStart = time.clone().startOf('day').add(17, 'hours');
        const dShiftEnd = time.clone().startOf('day').add(21, 'hours');



        console.log(time, bShiftStart, bShiftEnd, (time.isBetween(bShiftStart, bShiftEnd, 'minute', '[]')))
        if (time.isBetween(aShiftStart, aShiftEnd, 'minute', '[]')) return 'A';
        if (time.isBetween(gShiftStart, gShiftEnd, 'minute', '[]')) return 'G';
        if (time.isBetween(bShiftStart, bShiftEnd, 'minute', '[]')) return 'B';
        if (time.isBetween(dShiftStart, dShiftEnd, 'minute', '[]')) return 'D';
        return 'C';
    }

    private async insertConsolidatedLog(attnLog: AttendanceLogEntity): Promise<void> {
        const logDate: any = moment(attnLog.logDate).format('YYYY-MM-DD');
        let shift = '';
        let consolidatedLog = null;
        const acShiftStart = moment(attnLog.logDate).clone().startOf('day');
        const acShiftEnd = moment(attnLog.logDate).clone().startOf('day').add(8, 'hours');
        const time = moment(attnLog.logDate);
        if (attnLog.direction.toLowerCase() === 'in') {
            console.log('hhhhhhhhhhhh', time, acShiftStart, acShiftEnd, time.isBetween(acShiftStart, acShiftEnd, 'minute', '[]'))
            if ((time.isBetween(acShiftStart, acShiftEnd, 'minute', '[]'))) {
                //Mandatory A 
                const aShiftStart = moment(attnLog.logDate).clone().startOf('day').add(5, 'hours');
                const aShiftEnd = moment(attnLog.logDate).clone().startOf('day').add(8, 'hours').subtract(1, 'minute');
                if (time.isBetween(aShiftStart, aShiftEnd, 'minute', '[]')) {
                    const existingConsolidatedLog = await this.consolidatedAttendanceLogRepo.findOne({
                        where: {
                            employeeCode: attnLog.employeeCode,
                            logDate: logDate,
                        },
                    });
                    if (existingConsolidatedLog) {
                        consolidatedLog = existingConsolidatedLog;
                    } else {
                        shift = 'A';
                    }
                } else {
                    const existingConsolidatedLog = await this.consolidatedAttendanceLogRepo.findOne({
                        where: {
                            employeeCode: attnLog.employeeCode,
                            logDate: moment(logDate).subtract(1, 'day').format('YYYY-MM-DD'),
                            shift: In(['C', 'D'])
                        },
                    });
                    console.log(attnLog.employeeCode, 'attnLog.employeeCode')
                    consolidatedLog = existingConsolidatedLog;
                    if (existingConsolidatedLog) {
                        shift = existingConsolidatedLog.shift;
                    } else {
                        const cShiftStart = moment(attnLog.logDate).clone().startOf('day');
                        const cShiftEnd = moment(attnLog.logDate).clone().startOf('day').add(3, 'hours');
                        if (time.isSameOrAfter(cShiftStart) && time.isSameOrBefore(cShiftEnd)) {
                            shift = 'C'
                        } else {
                            shift = 'A'
                        }
                    }
                }
            } else {
                shift = this.determineShift(attnLog.logDate);
                console.log(shift, 'shiftuuuu')
            }
        } else {
            const existingConsolidatedLog = await this.consolidatedAttendanceLogRepo.findOne({
                where: {
                    employeeCode: attnLog.employeeCode,
                    logDate: moment(logDate).format('YYYY-MM-DD'),
                },
            });

            if (existingConsolidatedLog) {
                return await this.updateInTimeRecords(attnLog, existingConsolidatedLog);
            } else {
                const isPreviousLogExisting = await this.consolidatedAttendanceLogRepo.findOne({
                    where: {
                        employeeCode: attnLog.employeeCode,
                        logDate: moment(logDate).subtract(1, 'day').format('YYYY-MM-DD'),
                        shift: In(['C', 'D'])
                    },
                });
                if (isPreviousLogExisting) {
                    return await this.updateInTimeRecords(attnLog, isPreviousLogExisting)
                }
            }
        }
        //c,d

        if (consolidatedLog) {
            return await this.updateInTimeRecords(attnLog, consolidatedLog)
        } else {
            const existingConsolidatedLog = await this.consolidatedAttendanceLogRepo.findOne({
                where: {
                    employeeCode: attnLog.employeeCode,
                    logDate: moment(logDate).format('YYYY-MM-DD'),
                },
            });
            if (existingConsolidatedLog) {
                return await this.updateInTimeRecords(attnLog, existingConsolidatedLog)
            } else {
                //create 
                const consolidatedLog = new ConsolidatedAttendanceLogEntity();
                consolidatedLog.employeeName = attnLog.employeeName;
                consolidatedLog.employeeCode = attnLog.employeeCode;
                consolidatedLog.shift = shift;
                let logDate1: any = moment(logDate).format('YYYY-MM-DD');
                consolidatedLog.logDate = logDate1
                return await this.updateInTimeRecords(attnLog, consolidatedLog)
            }
        }

    }

    async updateInTimeRecords(attnLog: AttendanceLogEntity, consolidatedLog: ConsolidatedAttendanceLogEntity) {
        if (!consolidatedLog) {
            throw new ErrorResponse(13343, 'khdkfhsakdhkshdkhsad')
        }
        const logDate: any = attnLog.logDate;
        let totalHours = moment.duration(consolidatedLog.totalHours || '00:00');
        // Insert the in  punches into the consolidated log
        for (let i = 1; i <= 6; i++) {
            if (attnLog.direction.toLowerCase() === 'in') {
                if (!consolidatedLog[`inTime${i}`]) {
                    consolidatedLog[`inTime${i}`] = logDate;
                    break;
                }
            }
        }

        // Adjust for missing "in" punches between two "out" punches
        for (let i = 1; i <= 5; i++) {
            if (consolidatedLog[`outTime${i}`] && !consolidatedLog[`inTime${i + 1}`]) {
                // let inTimeZero = new Date(consolidatedLog[`outTime${i}`]);
                // inTimeZero.setHours(0, 0, 0, 0);
                consolidatedLog[`inTime${i + 1}`] = '0000-00-00T00:00:00.000Z';
                break;
            }
        }


        for (let i = 1; i <= 5; i++) {
            if (consolidatedLog[`inTime${i}`] && !consolidatedLog[`outTime${i}`] && consolidatedLog[`inTime${i + 1}`]) {
                // Use a placeholder string with "zeroed" date and time
                consolidatedLog[`outTime${i}`] = '0000-00-00T00:00:00.000Z'; // Custom format as a string
                break;
            }
        }

        // Ensure the latest out punch is recorded correctly
        if (attnLog.direction.toLowerCase() === 'out') {
            for (let i = 1; i <= 6; i++) {
                if (!consolidatedLog[`outTime${i}`] && consolidatedLog[`inTime${i}`]) {
                    consolidatedLog[`outTime${i}`] = logDate;

                    // Calculate the hours for this in/out pair and add to totalHours
                    const inTime = moment(consolidatedLog[`inTime${i}`]);
                    const outTime = moment(consolidatedLog[`outTime${i}`]);

                    if (!(inTime.hours() === 0 && inTime.minutes() === 0)) {
                        const duration = moment.duration(outTime.diff(inTime));
                        totalHours.add(duration);
                    }

                    consolidatedLog.totalHours = this.formatDuration(totalHours);
                    break;
                }
            }
        }

        await this.consolidatedAttendanceLogRepo.save(consolidatedLog);
    }
    private formatDuration(duration: moment.Duration): string {
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }


    // @Cron('*/15 * * * *')
    // async createAttendance(): Promise<AttendanceResponse> {
    //     const records = await this.attendanceLogRepo.getNonProcessedAttendanceLogs();
    //     if (records.length == 0) {
    //         return new AttendanceResponse(false, 11101, 'No logs found');
    //     } else {
    //         for (const record of records) {
    //             const empCode = record.employee_code;
    //             const date = moment(record.log_date).format('YYYY-MM-DD');
    //             const prevDate = moment(record.log_date).subtract(1, 'day').format('YYYY-MM-DD');
    //             const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
    //             const empRecord1 = await this.attendanceRepo.getEmpAttendanceRecordByDate(prevDate, empCode);
    //             if (!empRecord && !empRecord1) {
    //                 const emp = await this.attendanceHelperService.getEmployeeActiveInactive(empCode);
    //                 if (emp.status) {
    //                     if (!(emp.data.isActive)) {
    //                         await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
    //                     } else {
    //                         continue;
    //                     }
    //                 } else {
    //                     continue;
    //                 }
    //             } else {
    //                 const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
    //                 if (empInfo) {
    //                     if (!empRecord1 && empRecord) {
    //                         const time = moment(record.log_date).format('HH:mm:ss');
    //                         const inTime = moment(empRecord.in_time).format('HH:mm:ss');
    //                         const outTime = moment(empRecord.out_time).format('HH:mm:ss');
    //                         if (equals(empRecord.shift, 'C Shift')) {
    //                             const startDate = new Date('2022-11-20 21:00:00')
    //                             const startTime = moment(startDate).format('HH:mm:ss');
    //                             const date1 = new Date('2022-11-18 23:59:59');
    //                             const time1 = moment(date1).format('HH:mm:ss');
    //                             if (startTime <= time && time <= time1 && empRecord.present_status == 'A') {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date })
    //                             } else {
    //                                 if (startTime <= time && time <= time1 && empRecord.present_status == 'P') {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 } else {
    //                                     continue
    //                                 }
    //                             }
    //                         } else if (equals(empRecord.shift, 'X Shift')) {
    //                             const nDate = new Date('2022-1-3 16:00:00')
    //                             const nTime = moment(nDate).format('HH:mm:ss');
    //                             if (empRecord.present_status == 'A') {
    //                                 if (time < nTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                                 } else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
    //                                 }
    //                             } else if (empRecord.present_status == 'P') {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                             } else {
    //                                 continue;
    //                             }
    //                         } else if (equals(empRecord.shift, 'X1 Shift')) {
    //                             const nDate = new Date('2022-1-3 16:00:00')
    //                             const nTime = moment(nDate).format('HH:mm:ss');
    //                             if (empRecord.present_status == 'A') {
    //                                 if (time < nTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                                 } else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
    //                                 }
    //                             } else if (empRecord.present_status == 'P') {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                             } else {
    //                                 continue;
    //                             }
    //                         } else {
    //                             if (empRecord.present_status == 'A') {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                             } else if (empRecord.present_status == 'P') {
    //                                 if (time < inTime && inTime > outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
    //                                 } else if (time < inTime && inTime < outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
    //                                 } else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 }
    //                             } else {
    //                                 continue;
    //                             }
    //                         }
    //                         // update log status to processed 
    //                         await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
    //                     } else if (empRecord && empRecord1) {
    //                         const time = moment(record.log_date).format('HH:mm:ss');
    //                         const inTime = moment(empRecord.in_time).format('HH:mm:ss');
    //                         const outTime = moment(empRecord.out_time).format('HH:mm:ss');
    //                         if (equals(empRecord.shift, 'C Shift')) {
    //                             //const startTime = moment(shift.data[0].inTime).format('HH:mm:ss');
    //                             const startDate = new Date('2022-11-20 21:00:00')
    //                             const startTime = moment(startDate).format('HH:mm:ss');
    //                             //const endTime = moment(shift.data[0].outTime).format('HH:mm:ss');
    //                             const endDate = new Date('2022-11-20 06:59:00')
    //                             const endTime = moment(endDate).format('HH:mm:ss');
    //                             const date1 = new Date('2022-11-18 23:59:59');
    //                             const time1 = moment(date1).format('HH:mm:ss');
    //                             if (startTime <= time && time <= time1 && empRecord.present_status == 'A') {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date })
    //                             } else if (time <= endTime && empRecord1.present_status == 'A') {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                             } else {
    //                                 if (startTime <= time && time <= time1 && empRecord.present_status == 'P') {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 } else if (time <= endTime && empRecord1.present_status == 'P') {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
    //                                 } else {
    //                                     continue
    //                                 }
    //                             }
    //                         } else if (equals(empRecord.shift, 'X Shift')) {
    //                             let readFlag = 0;
    //                             const endDate = new Date('2022-11-20 09:59:00')
    //                             const endTime = moment(endDate).format('HH:mm:ss');
    //                             const mDate = new Date('2022-11-20 03:59:00')
    //                             const mTime = moment(mDate).format('HH:mm:ss');
    //                             // const date1 = moment.utc(record.log_date);
    //                             // const date2 = moment.utc(record.log_date).add(9, 'hours');
    //                             // const day1 = date1.date();
    //                             // const day2 = date2.date();
    //                             const nDate = new Date('2022-1-3 16:00:00')
    //                             const nTime = moment(nDate).format('HH:mm:ss');
    //                             if (empRecord.present_status == 'A' && time > nTime) {
    //                                 readFlag = 1;
    //                             }
    //                             if (empRecord.present_status == 'A') {
    //                                 if (time < mTime) {
    //                                     if (empRecord1.present_status == 'P') {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
    //                                     } else {
    //                                         continue;
    //                                     }
    //                                 } else if (time < endTime) {
    //                                     if (empRecord1.flag == 1) {
    //                                         if (empRecord1.present_status == 'P') {
    //                                             await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
    //                                         } else {
    //                                             await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, outTime: record.log_date });
    //                                         }
    //                                     } else {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                                     }
    //                                 } else {
    //                                     if (readFlag == 0) {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                                     } else if (readFlag == 1) {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
    //                                     }
    //                                 }
    //                             } else if (empRecord.present_status == 'P' && empRecord1.flag == 0) {
    //                                 if (time < inTime && inTime > outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
    //                                 } else if (time < inTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
    //                                 } else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 }
    //                             } else if (empRecord.present_status == 'P' && empRecord.flag == 0) {
    //                                 if (time < inTime && inTime > outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
    //                                 } else if (time < inTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
    //                                 } else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 };
    //                             } else if (empRecord.present_status == 'P' && empRecord.flag == 1) {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                             } else {
    //                                 continue;
    //                             }
    //                         } else if (equals(empRecord.shift, 'X1 Shift')) {
    //                             let readFlag = 0;
    //                             const endDate = new Date('2022-11-20 10:59:00')
    //                             const endTime = moment(endDate).format('HH:mm:ss');
    //                             const mDate = new Date('2022-11-20 03:59:00')
    //                             const mTime = moment(mDate).format('HH:mm:ss');
    //                             // const date1 = moment.utc(record.log_date);
    //                             // const date2 = moment.utc(record.log_date).add(12, 'hours');
    //                             // const day1 = date1.date();
    //                             // const day2 = date2.date();
    //                             const nDate = new Date('2022-1-3 16:00:00');
    //                             const nTime = moment(nDate).format('HH:mm:ss');
    //                             if (empRecord.present_status == 'A' && time > nTime) {
    //                                 readFlag = 1;
    //                             }
    //                             if (empRecord.present_status == 'A') {
    //                                 if (time < mTime) {
    //                                     if (empRecord1.present_status == 'P') {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
    //                                     } else {
    //                                         continue;
    //                                     }
    //                                 } else if (time < endTime) {
    //                                     if (empRecord1.flag == 1) {
    //                                         if (empRecord1.present_status == 'P') {
    //                                             await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
    //                                         } else {
    //                                             await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, outTime: record.log_date });
    //                                         }
    //                                     } else {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                                     }
    //                                 } else {
    //                                     if (readFlag == 0) {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                                     } else if (readFlag == 1) {
    //                                         await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
    //                                     }
    //                                 }
    //                             } else if (empRecord.present_status == 'P' && empRecord1.flag == 0) {
    //                                 if (time < inTime && inTime > outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
    //                                 } else if (time < inTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
    //                                 } else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 }
    //                             } else if (empRecord.present_status == 'P' && empRecord.flag == 0) {
    //                                 if (time < inTime && inTime > outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
    //                                 } else if (time < inTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
    //                                 } else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 };
    //                             } else if (empRecord.present_status == 'P' && empRecord.flag == 1) {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                             } else {
    //                                 continue;
    //                             }
    //                         } else {
    //                             if (empRecord.present_status == 'A') {
    //                                 await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
    //                             } else if (empRecord.present_status == 'P') {
    //                                 if (time < inTime && inTime > outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
    //                                 } else if (time < inTime && inTime < outTime) {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
    //                                 }
    //                                 // else if (time > inTime && time < outTime) {
    //                                 //     await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
    //                                 // } 
    //                                 else {
    //                                     await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
    //                                 }
    //                             } else {
    //                                 continue;
    //                             }
    //                         }
    //                         // update log status to processed 
    //                         await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
    //                     } else {
    //                         continue;
    //                     }
    //                 } else {
    //                     continue;
    //                     // await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
    //                 }
    //             }
    //         }
    //         return new AttendanceResponse(true, 11101, 'Logged Successfully');
    //     }
    // }

    @Cron('*/15 * * * *')
    async createAttendance(): Promise<AttendanceResponse> {
        const records = await this.attendanceLogRepo.getNonProcessedAttendanceLogs();
        if (records.length == 0) {
            return new AttendanceResponse(false, 11101, 'No logs found');
        } else {
            for (const record of records) {
                const empCode = record.employee_code;
                const date = moment(record.log_date).format('YYYY-MM-DD');
                const prevDate = moment(record.log_date).subtract(1, 'day').format('YYYY-MM-DD');
                const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
                const empRecord1 = await this.attendanceRepo.getEmpAttendanceRecordByDate(prevDate, empCode)
                if (!empRecord && !empRecord1) {
                    const emp = await this.attendanceHelperService.getEmployeeActiveInactive(empCode);
                    if (emp.status) {
                        if (!(emp.data.isActive)) {
                            await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                        } else {
                            continue;
                        }
                    } else {
                        continue;
                    }
                } else {
                    const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
                    // console.log(empInfo, 'empInfo')
                    if (empInfo) {
                        const logTime = moment(record.log_date).format('HH:mm:ss')
                        // console.log(record.log_date, 'logTime')
                        const aInTime1 = '05:00:00';
                        const aInTime2 = '07:59:59';
                        const bInTime1 = '13:00:00';
                        const bInTime2 = '16:59:59';
                        const cInTime1 = '21:00:00';
                        const cInTime2 = '03:59:59';
                        const dInTime1 = '17:00:00';
                        const dInTime2 = '20:59:59';
                        const gInTime1 = '08:00:00';
                        const gInTime2 = '12:59:59';
                        const aTime1 = moment(aInTime1, 'HH:mm:ss').format('HH:mm:ss');
                        const aTime2 = moment(aInTime2, 'HH:mm:ss').format('HH:mm:ss');
                        const bTime1 = moment(bInTime1, 'HH:mm:ss').format('HH:mm:ss');
                        const bTime2 = moment(bInTime2, 'HH:mm:ss').format('HH:mm:ss');
                        const cTime1 = moment(cInTime1, 'HH:mm:ss').format('HH:mm:ss');
                        const cTime2 = moment(cInTime2, 'HH:mm:ss').format('HH:mm:ss');
                        const dTime1 = moment(dInTime1, 'HH:mm:ss').format('HH:mm:ss');
                        const dTime2 = moment(dInTime2, 'HH:mm:ss').format('HH:mm:ss');
                        const gTime1 = moment(gInTime1, 'HH:mm:ss').format('HH:mm:ss');
                        const gTime2 = moment(gInTime2, 'HH:mm:ss').format('HH:mm:ss');
                        if (!empRecord1 && empRecord) {
                            if (logTime <= aTime2) {
                                if (empRecord.present_status == 'A') {
                                    if (logTime > aTime1 && logTime < aTime2) {
                                        if (record.direction == 'IN') {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'A'
                                            })
                                        } else if (record.direction == 'OUT') {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                        }
                                    } else {
                                        continue;
                                    }
                                } else if (empRecord.present_status == 'WO') {
                                    if (logTime > aTime1 && logTime < aTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'A'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    }
                                } else if (empRecord.present_status == 'PH') {
                                    if (logTime > aTime1 && logTime < aTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'A'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    }
                                } else if (empRecord.present_status == 'P') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                        outTime: record.log_date
                                    })
                                } else if (empRecord.present_status == 'WP') {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'PHP') {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                    }
                                }
                            } else {
                                if (empRecord.present_status == 'A') {
                                    if (logTime > bTime1 && logTime < bTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'B'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                    } else if (logTime > cTime1 && logTime < "23:59:59" || logTime > "00:00:01" && logTime < cTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'C'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                    } else if (logTime > dTime1 && logTime < dTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'D'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                    } else if (logTime > gTime1 && logTime < gTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'G'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                    }
                                } else if (empRecord.present_status == 'WO') {
                                    if (logTime > bTime1 && logTime < bTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'B'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })

                                    } else if (logTime > cTime1 && logTime < "23:59:59" || logTime > "00:00:01" && logTime < cTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'C'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    } else if (logTime > dTime1 && logTime < dTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'D'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    } else if (logTime > gTime1 && logTime < gTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'G'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    }
                                } else if (empRecord.present_status == 'PH') {
                                    if (logTime > bTime1 && logTime < bTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'B'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })

                                    } else if (logTime > cTime1 && logTime < "23:59:59" || logTime > "00:00:01" && logTime < cTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'C'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    } else if (logTime > dTime1 && logTime < dTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'D'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    } else if (logTime > gTime1 && logTime < gTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'G'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    }
                                } else {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                }
                            }
                        } else if (empRecord && empRecord1) {
                            if (logTime <= aTime2) {
                                if (empRecord.present_status == 'A' && empRecord1.flag == 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                    } else if (record.direction == 'IN') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                            logDate: record.log_date,
                                            downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'A'
                                        })
                                    }
                                } else if (empRecord.present_status == 'P' && empRecord1.flag == 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'WP' && empRecord1.flag == 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'PHP' && empRecord1.flag == 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'P' && empRecord1.flag !== 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'WP' && empRecord1.flag !== 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'PHP' && empRecord1.flag !== 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'A' && empRecord1.flag != 1) {
                                    if (logTime > aTime1 && logTime < aTime2) {
                                        if (record.direction == 'IN')
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'A'
                                            })
                                        if (record.direction == 'OUT')
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                    } else {
                                        continue;
                                    }
                                } else if (empRecord.present_status == 'WO' && empRecord1.flag == 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                    } else if (record.direction == 'IN') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                            logDate: record.log_date,
                                            downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'A'
                                        })
                                    }
                                } else if (empRecord.present_status == 'WO' && empRecord1.flag != 1) {
                                    if (logTime > aTime1 && logTime < aTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'A'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    }
                                } else if (empRecord.present_status == 'PH' && empRecord1.flag == 1) {
                                    if (record.direction == 'OUT') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                    } else if (record.direction == 'IN') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                            logDate: record.log_date,
                                            downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'A'
                                        })
                                    }
                                } else if (empRecord.present_status == 'PH' && empRecord1.flag != 1) {
                                    if (logTime > aTime1 && logTime < aTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'A'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    }
                                }
                            } else {
                                if (empRecord.present_status == 'A') {
                                    if (logTime > bTime1 && logTime < bTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'B'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                    } else if (logTime > cTime1 && logTime < "23:59:59" || logTime > "00:00:01" && logTime < cTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'C'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                    } else if (logTime > dTime1 && logTime < dTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'D'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date,
                                            })
                                    } else if (logTime > gTime1 && logTime < gTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, shift: 'G'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', outTime: record.log_date
                                            })
                                    }
                                } else if (empRecord.present_status == 'WO') {
                                    if (logTime > bTime1 && logTime < bTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'B'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    } else if (logTime > cTime1 && logTime < "23:59:59" || logTime > "00:00:01" && logTime < cTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'C'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    } else if (empRecord.present_status == 'WO') {
                                        if (logTime > dTime1 && logTime < dTime2)
                                            if (record.direction == "IN")
                                                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                    logDate: record.log_date, flag: 1,
                                                    downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'D'
                                                })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    } else if (empRecord.present_status == 'WO') {
                                        if (logTime > gTime1 && logTime < gTime2)
                                            if (record.direction == "IN")
                                                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                    logDate: record.log_date,
                                                    downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', inTime: record.log_date, shift: 'G'
                                                })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'WP', outTime: record.log_date
                                            })
                                    }
                                } else if (empRecord.present_status == 'PH') {
                                    if (logTime > bTime1 && logTime < bTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'B'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })

                                    } else if (logTime > cTime1 && logTime < "23:59:59" || logTime > "00:00:01" && logTime < cTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'C'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    } else if (logTime > dTime1 && logTime < dTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'D'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date, flag: 1,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    } else if (logTime > gTime1 && logTime < gTime2) {
                                        if (record.direction == "IN")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', inTime: record.log_date, shift: 'G'
                                            })
                                        if (record.direction == "OUT")
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, {
                                                logDate: record.log_date,
                                                downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'PHP', outTime: record.log_date
                                            })
                                    }
                                } else {
                                    if (record.direction == 'OUT')
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    else if (record.direction == 'IN')
                                        continue;
                                }
                            }
                        } else {
                            continue;
                        }
                    } else {
                        continue;
                    }
                    await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                }
            }
            return new AttendanceResponse(true, 11101, 'Logged Successfully');
        }
    }


    async attendanceAdjustment(attnAdjustLogReq: AttnAdjustLogReq): Promise<any> {
        const transManager = new GenericTransactionManager();
        const req = new AttendanceAdjustRequest();
        req.employeeCode = attnAdjustLogReq.employeeCode;
        req.date = attnAdjustLogReq.date;
        const appliedDate = new Date();
        const attnData = await this.getAdjustmentData(req);
        await transManager.startTransaction();
        const attnAdjust = await transManager.getCustomRepository(AttendanceAdjustmentRepository).findOne({ where: { employeeCode: attnAdjustLogReq.employeeCode, date: req.date } })
        if (attnAdjust) {
            const attnAdjustUpdate = await transManager.getCustomRepository(AttendanceAdjustmentRepository).update({ employeeCode: attnAdjustLogReq.employeeCode, date: req.date }, { inTime: attnAdjustLogReq.inTime, outTime: attnAdjustLogReq.outTime, presentStatus: attnAdjustLogReq.presentStatus, reason: attnAdjustLogReq.reason, remarks: attnAdjustLogReq.remarks, updatedUser: attnAdjustLogReq.user, status: LeaveApprovalStatusEnum.OPEN });
            if (attnAdjustUpdate.affected) {
                await transManager.completeTransaction();
                return new GlobalResponseObject(true, 11105, "Attendance adjustment updated for this employee for the date" + req.date);
            } else {
                await transManager.releaseTransaction();
                return new GlobalResponseObject(false, 11106, 'Something Went Wrong In Attendance update');
            }
        } else {
            const convertedAttnLogEntity: AttendanceAdjustment = this.attendanceAdjustmentAdapter.convertDtoToEntity(attnData.data.employeeId, attnData.data.employeeCode, attnData.data.employeeName, req.date, attnData.data.inTime, attnAdjustLogReq.inTime, attnData.data.outTime, attnAdjustLogReq.outTime, attnAdjustLogReq.presentStatus, attnData.data.departmentId, attnData.data.shiftGroup, attnData.data.unitId, attnData.data.shift, attnAdjustLogReq.reason, attnAdjustLogReq.remarks, appliedDate, attnAdjustLogReq.user);
            const savedAttenLogEntity = await transManager.getCustomRepository(AttendanceAdjustmentRepository).save(convertedAttnLogEntity);
            if (savedAttenLogEntity) {
                // const savedAttnLogModel: AttendanceAdjustmentDto = this.attendanceAdjustmentAdapter.convertEntityToDto(savedAttenLogEntity);
                await transManager.completeTransaction();
                return new GlobalResponseObject(true, 11101, ' Attendance adjustment applied Successfully');
            } else {
                await transManager.releaseTransaction();
                return new GlobalResponseObject(false, 11106, 'Something Went Wrong In Attendance Saving');
            }
        }
    }

    async getAttnAdjustTableData(): Promise<CommonResponse> {
        const transManager = new GenericTransactionManager();
        await transManager.startTransaction();
        const datas = await transManager.getCustomRepository(AttendanceAdjustmentRepository).find({ order: { appliedDate: 'DESC' } });
        if (datas) {
            await transManager.completeTransaction();
        } else {
            await transManager.releaseTransaction()
        }
        const response = [];
        for (const data of datas) {
            const tableData = this.attendanceAdjustmentAdapter.convertEntityToDto(data);
            response.push(tableData);
        }
        if (response) {
            return new CommonResponse(true, 11107, 'Data retrieved successfully', response);
        } else {
            await transManager.releaseTransaction();
            return new CommonResponse(false, 11106, ' Data not Found ');
        }
    }

    async updateAttendance(attnUpdateReq: AttendanceUpdateRequest): Promise<AttendanceResponse> {
        const date = attnUpdateReq.date;
        const empCode = attnUpdateReq.employeeCode;
        const transManager = new GenericTransactionManager();
        const currDate = new Date();
        const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
        if (empRecord) {
            await transManager.startTransaction();
            if (attnUpdateReq.status == LeaveApprovalStatusEnum.APPROVED) {
                const attenUpdate = await transManager.getCustomRepository(AttendanceRepository).update({ employeeCode: empCode, date: date }, { logDate: currDate, downloadDate: date, deviceCode: 'Manual', verifyMode: 'Manual', presentStatus: attnUpdateReq.presentStatus, inTime: attnUpdateReq.inTime, outTime: attnUpdateReq.outTime, updatedUser: attnUpdateReq.user });
                if (attenUpdate.affected) {
                    const attenAdjUpdate = await transManager.getCustomRepository(AttendanceAdjustmentRepository).update({ employeeCode: empCode, date: date }, { status: LeaveApprovalStatusEnum.APPROVED, updatedUser: attnUpdateReq.user });
                    if (attenAdjUpdate.affected) {
                        await transManager.completeTransaction();
                        return new AttendanceResponse(true, 11101, 'Attendance Approved and Updated Successfully');
                    } else {
                        await transManager.releaseTransaction();
                        return new AttendanceResponse(false, 11101, 'Something went wrong in attendance adjustment updation');
                    }
                } else {
                    await transManager.releaseTransaction();
                    return new AttendanceResponse(false, 11101, 'Something went wrong in attendance updation');
                }
            } else if (attnUpdateReq.status == LeaveApprovalStatusEnum.REJECTED) {
                const rejUpdate = await transManager.getCustomRepository(AttendanceAdjustmentRepository).update({ employeeCode: empCode, date: date }, { status: LeaveApprovalStatusEnum.REJECTED, updatedUser: attnUpdateReq.user });
                if (rejUpdate.affected) {
                    await transManager.completeTransaction();
                    return new AttendanceResponse(true, 11101, 'Attendance Rejected Successfully');
                } else {
                    await transManager.releaseTransaction();
                    return new AttendanceResponse(false, 11101, 'Something went wrong in rejection of attendance');
                }
            }
        }
        else {
            return new AttendanceResponse(false, 11106, 'Record already updated for this Employee');
        }
    }

    async updateLeave(req: LeaveUpdateRequest): Promise<AttendanceResponse> {
        const fromDate = new Date(req.fromDate);
        const toDate = new Date(req.toDate);
        const empCode = req.employeeCode;
        const fromDay = req.fromDay;
        const toDay = req.toDay;
        for (var i = new Date(fromDate); i <= new Date(toDate); i.setDate(i.getDate() + 1)) {
            const date1 = i.getFullYear() + '-' + (Number(i.getMonth()) + 1) + '-' + i.getDate();
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date1, empCode);
            if (empRecord.present_status == 'A') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { presentStatus: 'L' });
            } else if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { presentStatus: 'H' });
            }
        }
        if (fromDay === "First Half" || fromDay === "Second Half") {
            const date = fromDate.getFullYear() + '-' + (Number(fromDate.getMonth()) + 1) + '-' + fromDate.getDate()
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { leaveStatus: 'HDL' });
            }
        } else if (toDay === "First Half" || toDay === "Second Half") {
            const date = toDate.getFullYear() + '-' + (Number(toDate.getMonth()) + 1) + '-' + toDate.getDate()
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { leaveStatus: 'HDL' });
            }
        } else if ((fromDay === "First Half" || fromDay === "Second Half") && (toDay === "First Half" || toDay === "Second Half")) {
            const date = fromDate.getFullYear() + '-' + (Number(fromDate.getMonth()) + 1) + '-' + fromDate.getDate()
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { leaveStatus: 'HDL' });
            }
            const date1 = toDate.getFullYear() + '-' + (Number(toDate.getMonth()) + 1) + '-' + toDate.getDate()
            const empRecord1 = await this.attendanceRepo.getEmpAttendanceRecordByDate(date1, empCode);
            if (empRecord1.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { leaveStatus: 'HDL' });
            }
        }
        return new AttendanceResponse(true, 11101, 'Leave updated successfully')
    }

    async updateEmpLogsByShift(req: EmpCodeShiftRequest): Promise<AttendanceResponse> {
        const empCodes = req.employeeCodes;
        const shiftCode = req.shiftCode;
        for (const empCode of empCodes) {
            const records = await this.attendanceHelperService.getTeamCalenderRecords(shiftCode);
            for (const record of records) {
                const dateOne = new Date(req.fromDate);
                const dateTwo = new Date(req.toDate);
                for (var i = dateOne; i <= dateTwo; i.setDate(i.getDate() + 1)) {
                    const date = i.getFullYear() + '-' + (Number(i.getMonth()) + 1) + '-' + i.getDate();
                    const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
                    if (empRecord) {
                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { shiftGroup: shiftCode, shift: record.shift });
                    } else {
                        return new AttendanceResponse(false, 111101, 'Could not find employee record');
                    }
                }
            }
        }
        return new AttendanceResponse(true, 11101, 'Updated successfully');
    }

    // async createEmpAttendanceLogs(req: EmployeeCodesRequest): Promise<AttendanceResponse> {
    //     const empCodes = req.employeeCodes;
    //     for (const empCode of empCodes) {
    //         const currDate = new Date();
    //         const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
    //         const dateOne = new Date(2023, 1, 1);
    //         const dateTwo = new Date(2023, 3, 27);
    //         const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
    //         if (!empInfo) {
    //             continue;
    //         }
    //         let shift = '';
    //         if (empInfo.employeeType == 'Labour Form') {
    //             shift = 'X Shift'
    //         }
    //         let flagMap = new Set<boolean>();
    //         for (var i = dateOne; i <= dateTwo; i.setDate(i.getDate() + 1)) {
    //             console.log(empCode)
    //             const date1 = i.getFullYear() + '-' + (Number(i.getMonth()) + 1) + '-' + i.getDate();
    //             const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date1, empCode);
    //             if (!empRecord) {
    //                 // check and get the employee based on empCode
    //                 const empAttnEnt = this.AttendanceAdapter.getAttendanceEntity(empInfo.employeeId, date1, null, empCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, null, null, 'A', null, null, null, shift, Number(empInfo.departmentId), null, empInfo.designation, empInfo.unitId, i.getDate(), (Number(i.getMonth()) + 1), i.getFullYear());
    //                 const saveEntity = await this.attendanceRepo.save(empAttnEnt);
    //                 if (saveEntity) {
    //                     flagMap.add(true);
    //                 } else {
    //                     flagMap.add(false);
    //                     break;
    //                 }
    //             } else {
    //                 continue;
    //             }
    //             if (!flagMap.has(false)) {
    //                 continue;
    //             } else {
    //                 return new AttendanceResponse(false, 1111, 'Something went wrong while creating logs');
    //             }
    //         }
    //     }
    //     return new AttendanceResponse(true, 11101, 'Logs created successfully');
    // }



    @Cron('0 23 * * *')
    async createEmpAttendanceLogs(req?: EmployeeCodesRequest): Promise<AttendanceResponse> {
        const empCodes = [];
        const empDetails = await this.attendanceHelperService.getAllActiveEmployees();
        for (const empDetail of empDetails) {
            empCodes.push(empDetail.employeeCode);
        }
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const nextDate = tomorrow.getFullYear() + '-' + (Number(tomorrow.getMonth()) + 1) + '-' + tomorrow.getDate();
        const nextDate1 = `${tomorrow.getFullYear()}-${String(tomorrow.getMonth() + 1).padStart(2, '0')}-${String(tomorrow.getDate()).padStart(2, '0')}`;
        const dayOfWeek = tomorrow.getDay();
        const daysOfWeek = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
        const tomorrowDayName = daysOfWeek[dayOfWeek];
        // console.log(`Tomorrow is ${tomorrowDayName}`)
        for (const empCode of empCodes) {
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(nextDate, empCode);
            if (!empRecord) {
                // check and get the employee based on empCode
                const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
                // console.log(empInfo, 'empInfoempInfo')
                if (!empInfo) {
                    continue;
                }
                let holidayStatus = 'A';

                try {
                    const holidays = await this.attendanceHelperService.getAllActiveHolidaysByNextDay(nextDate1);
                    if (holidays.length > 0) {
                        holidayStatus = 'PH';
                    }
                } catch (error) {
                    // console.error('Error fetching holidays:', error);
                }

                try {
                    const weekOff = await this.attendanceHelperService.getWeekOffByEmpCode(empCode);
                    if (weekOff.some(wo => wo.weekOffDay === tomorrowDayName)) {
                        holidayStatus = 'WO';
                    } else if (empInfo.employeeType == 'Labour Form' && tomorrowDayName === 'SUNDAY') {
                        holidayStatus = 'WO';
                        // console.log(`Labour employee ${empCode} has week-off on Sunday: setting status to WO`);
                    }
                } catch (error) {
                    // console.error('Error fetching week off:', error);
                }

                // console.log(`Employee ${empCode}: holidayStatus = ${holidayStatus}`);

                const day = tomorrow.getDate();
                const month = Number(tomorrow.getMonth()) + 1;
                const year = tomorrow.getFullYear();
                const departmentId = Number(empInfo.departmentId);

                // console.log(`Creating attendance entity with: day=${day}, month=${month}, year=${year}, departmentId=${departmentId}`);

                const empAttnEnt = this.AttendanceAdapter.getAttendanceEntity(
                    empInfo.employeeId, nextDate, null, empCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, null, null, holidayStatus, null, null, null, null,
                    departmentId, null, empInfo.designation, empInfo.unitId, day, month, year
                );
                const saveEntity = await this.attendanceRepo.save(empAttnEnt);
                if (saveEntity) {
                    continue;
                } else {
                    return new AttendanceResponse(false, 1111, 'Something went wrong while creating logs');
                }
            } else {
                continue;
            }
        }
        return new AttendanceResponse(true, 11101, 'Logs created successfully');
    }


    async createEmpAttnLogForToday(req?: EmployeeCodesRequest): Promise<AttendanceResponse> {
        const empCodes = [];
        const empDetails = await this.attendanceHelperService.getAllActiveEmployees();
        for (const empDetail of empDetails) {
            empCodes.push(empDetail.employeeCode);
        }
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
        for (const empCode of empCodes) {
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (!empRecord) {
                // check and get the employee based on empCode
                const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
                if (!empInfo) {
                    continue;
                }
                let shift = '';
                if (empInfo.employeeType == 'Labour Form') {
                    shift = 'X Shift'
                }
                const empAttnEnt = this.AttendanceAdapter.getAttendanceEntity(empInfo.employeeId, date, null, empCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, null, null, 'A', null, null, null, shift ? shift : empInfo.shiftGroup, Number(empInfo.departmentId), null, empInfo.designation, empInfo.unitId, currDate.getDate(), (Number(currDate.getMonth()) + 1), currDate.getFullYear());
                const saveEntity = await this.attendanceRepo.save(empAttnEnt);
                if (saveEntity) {
                    continue;
                } else {
                    return new AttendanceResponse(false, 1111, 'Something went wrong while creating logs');
                }
            } else {
                continue;
                // return new AttendanceResponse(false, 1111, 'Logs Already Created for this Employee');
            }
        }
        return new AttendanceResponse(true, 11101, 'Log created successfully');
    }

    async getDataForEmpShiftMapping(): Promise<EmployeeDataModelResponse> {
        const empInfos = await this.attendanceHelperService.getAllActiveEmployees();
        const empDataModel: EmployeeDataModel[] = [];
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        for (const empInfo of empInfos) {
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + Number(currDate.getDate());
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empInfo.employeeCode);
            const empData = new EmployeeDataModel(empInfo.employeeId, empInfo.employeeCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, empInfo.designation, deptNameMap.get(empRecord.department_id), empRecord.shift_group);
            empDataModel.push(empData);
        }
        return new EmployeeDataModelResponse(true, 11101, 'Data retrived successfully', empDataModel);
    }

    async getAllNonProcessedAttendanceLogs(): Promise<AttendanceLogResponse> {
        try {
            const attnLogDto: AttendanceLogModel[] = [];
            const attnLogEntities: AttendanceLogEntity[] = await this.attendanceLogRepo.find({
                order: { 'logDate': 'DESC' }, where: { status: false }
            });
            if (attnLogEntities) {
                attnLogEntities.forEach(attnLogEntitiy => {
                    const convertedattnLogDto: AttendanceLogModel = this.AttendanceLogAdapter.convertEntityToDto(attnLogEntitiy);
                    attnLogDto.push(convertedattnLogDto);
                });
                return new AttendanceLogResponse(true, 11101, 'Data retrived successfully', attnLogDto);
            } else {
                return new AttendanceLogResponse(false, 99998, 'No Logs found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAttendanceData(empAttnReq: EmployeeAttendanceRequest): Promise<EmployeeAttendanceResponse> {
        const date = empAttnReq.date;
        const deptId = empAttnReq.departmentId;
        const empAttenResponseMap = new Map<number, EmployeeDataModel[]>();
        const records = await this.attendanceRepo.getAttendanceRecordsByDate(date, deptId);
        if (records.length == 0) {
            return new EmployeeAttendanceResponse(false, 0, 'No data found');
        }
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        const empsInfo = await this.attendanceHelperService.getAllActiveEmployees();
        const empsInfoMap = new Map<number, EmployeeDto>();
        empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
        for (const record of records) {
            const empId = Number(record.employee_id);
            const empInfo = empsInfoMap.get(empId);
            if (!empAttenResponseMap.has(record.department_id)) {
                empAttenResponseMap.set(record.department_id, []);
            }
            empAttenResponseMap.get(record.department_id).push(new EmployeeDataModel(empInfo.employeeId, empInfo.employeeCode, empInfo.employeeName, empInfo.designation));
        }
        const empsModelArray: DeptWiseDataModel[] = [];
        for (const [key, empDetailes] of empAttenResponseMap) {
            const empCount = await this.attendanceRepo.getDeptEmpCountShiftWise(date, key);
            const totalCount = empCount.count;
            let presentCount = 0;
            empDetailes.forEach(emp => presentCount = presentCount + 1);
            empsModelArray.push(new DeptWiseDataModel(key, deptNameMap.get(key), empDetailes, totalCount, presentCount));
        }
        return new EmployeeAttendanceResponse(true, 0, 'Retrieved successfully', empsModelArray);
    }

    async getAttendanceDataShiftWise(empAttnReq: EmployeeAttendanceRequest): Promise<EmployeeShiftAttendanceResponse> {
        const date = empAttnReq.date;
        const shift = empAttnReq.shift;
        const unitId = empAttnReq.unitId;
        const empAttenResponseMap = new Map<string, DeptDataModel[]>();
        const records = await this.attendanceRepo.getAttendanceRecordsByDateAndShift(date, shift, unitId);
        if (records.length == 0) {
            return new EmployeeShiftAttendanceResponse(false, 0, 'No data found');
        }
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        const empsInfo = await this.attendanceHelperService.getAllActiveEmployees();
        const empsInfoMap = new Map<number, EmployeeDto>();
        empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
        for (const record of records) {
            if (!empAttenResponseMap.has(record.shift)) {
                empAttenResponseMap.set(record.shift, []);
            }
            const empCount = await this.attendanceRepo.getDeptEmpCountShiftWise(date, record.department_id, record.shift);
            const totalCount = empCount.count;
            empAttenResponseMap.get(record.shift).push(new DeptDataModel(record.department_id, deptNameMap.get(record.department_id), totalCount, record.count));
        }
        const empsModelArray: ShiftWiseDataModel[] = [];
        for (const [key, deptDetailes] of empAttenResponseMap) {
            empsModelArray.push(new ShiftWiseDataModel(key, deptDetailes));
        }
        return new EmployeeShiftAttendanceResponse(true, 0, 'Retrieved successfully', empsModelArray);
    }

    async getAttendanceCountShiftWise(shiftAttnReq: ShiftAttendanceRequest): Promise<EmployeeShiftCountResponse> {
        const fromDate = shiftAttnReq.fromDate;
        const toDate = shiftAttnReq.toDate;
        const shift = shiftAttnReq.shift;
        const empAttenResponseMap = new Map<string, AttnCountModel[]>();
        const records = await this.attendanceRepo.getShiftWiseAttendanceByDate(fromDate, toDate);
        if (records.length == 0) {
            return new EmployeeShiftCountResponse(false, 0, 'No data found');
        }
        for (const record of records) {
            if (!empAttenResponseMap.has(record.shift)) {
                empAttenResponseMap.set(record.shift, []);
            }
            const date = record.log_date.getFullYear() + '-' + (Number(record.log_date.getMonth()) + 1) + '-' + record.log_date.getDate();
            const empCount = await this.attendanceRepo.getShiftWiseEmpCountByDate(date, record.shift);
            let totalCount = 0;
            for (const emp of empCount) {
                totalCount = emp.count;
            }
            empAttenResponseMap.get(record.shift).push(new AttnCountModel(date, totalCount, record.count));
        }
        const empsModelArray: ShiftWiseCountModel[] = [];
        for (const [key, attnDetailes] of empAttenResponseMap) {
            empsModelArray.push(new ShiftWiseCountModel(key, attnDetailes));
        }
        return new EmployeeShiftCountResponse(true, 0, 'Retrieved successfully', empsModelArray);
    }

    async getMonthWiseAttendanceReport(monthReq: AttendanceMonthRequest): Promise<MonthAttendanceResponse> {
        // console.log(monthReq, 'monthReqmonthReq')
        try {
            const year = monthReq.year
            const month = monthReq.month;
            const deptId = monthReq.departmentId;
            const unitId = monthReq.unitId;
            const empAttenResponseMap = new Map<number, MonthAttnDataModel>();
            const records = await this.attendanceRepo.getAttendanceRecordsByMonth(year, month, deptId, unitId);
            if (records.length == 0) {
                return new MonthAttendanceResponse(false, 0, 'No data found');
            }
            const unitInfo = await this.attendanceHelperService.getAllUnitcodes();
            const unitNameMap = new Map<number, string>();
            unitInfo.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const empsInfo = await this.attendanceHelperService.getAllEmployees();
            const empsInfoMap = new Map<number, EmployeeDto>();
            empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
            const otHoursInfo = await this.overTimeService.getOTHoursByEmployeeCode(monthReq);
            const otHoursInfoMap = new Map<string, number>();
            otHoursInfo.data.forEach(emp => otHoursInfoMap.set(emp.employeeCode, emp.otHours));
            const otShiftInfo = await this.overTimeService.getOTShiftsByEmployeeCode(monthReq);
            const otShiftInfoMap = new Map<string, number>();
            otShiftInfo.data.forEach(emp => otShiftInfoMap.set(emp.employeeCode, emp.otShifts));
            for (const record of records) {
                const empId = Number(record.employee_id);
                const empInfo = empsInfoMap.get(empId);
                if (!empAttenResponseMap.has(empInfo.employeeId)) {
                    const empRecords = await this.attendanceRepo.getMonthRecordsForEmp(year, empInfo.employeeId, month);
                    let presentCount = 0;
                    let outDoorCount = 0;
                    let absentCount = 0;
                    let compOffCount = 0;
                    let workFromHomeCount = 0;
                    let leaveCount = 0;
                    let weekOffCount = 0;
                    let publicHolidayCount = 0;
                    let notOutPunchCount = 0;
                    let totalDaysCount = 0;
                    let totalPresentDays = 0;
                    let payableDays = 0;
                    let monthDays = 0
                    const daysInMonth = {
                        1: 31,
                        2: new Date(year, 1, 29).getMonth() === 1 ? 29 : 28,
                        3: 31,
                        4: 30,
                        5: 31,
                        6: 30,
                        7: 31,
                        8: 31,
                        9: 30,
                        10: 31,
                        11: 30,
                        12: 31
                    };
                    monthDays = daysInMonth[month];
                        const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
                        const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];

                    const daysCount = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;

                    for (const empRecord of empRecords) {
                        const status = empRecord.present_status;
                        const count = Number(empRecord.count);
                        if (['P', 'P/CO', 'P/L', 'P/OD', 'P/2'].includes(status)) {
                            if (status === 'P') {
                                presentCount += count;
                            } else if (['P/CO', 'P/L'].includes(status)) {
                                presentCount += count * 0.5;
                            } else if (status === 'P/2') {
                                presentCount += count * 0.5;
                                absentCount += count * 0.5;
                            } else if (status === 'P/OD') {
                                presentCount += count * 0.5;
                                outDoorCount += count * 0.5;
                            }

                        } else if (['WO', 'WP', 'WP/2', 'WNIP', 'WNOP'].includes(status)) {
                            weekOffCount += count;
                        } else if (['PH', 'PHP', 'PHNOP', 'PHNIP', 'PHP/2'].includes(status)) {
                            publicHolidayCount += count;
                        } else if (['OD'].includes(status)) {
                            outDoorCount += count;
                        } else if (['L', 'P/L', 'CO/L', 'L/2'].includes(status)) {
                            leaveCount += (status === 'P/L' || status === 'CO/L' || status === 'L/2') ? count * 0.5 : count;
                        } else if (['CO', 'P/CO', 'CO/2', 'CO/L'].includes(status)) {
                            compOffCount += (status === 'P/CO' || status === 'CO/2' || status === 'CO/L') ? count * 0.5 : count;
                        } else if (['NOP', 'NIP'].includes(status)) {
                            notOutPunchCount += count;
                        } else if (status === 'A') {
                            absentCount += count;
                        }
                    }
                    totalDaysCount = presentCount + outDoorCount + leaveCount + weekOffCount + publicHolidayCount + compOffCount

                    if (totalDaysCount === daysCount) {
                        payableDays = monthDays;
                    } else {
                        payableDays = monthDays - (daysCount - totalDaysCount)
                    }

                    empAttenResponseMap.set(empInfo.employeeId, new MonthAttnDataModel(
                        empInfo.employeeCode,
                        `${empInfo.employeeName} ${empInfo.employeeLastName}`,
                        deptNameMap.get(record.department_id),
                        empInfo.contractorName,
                        record.shift,
                        empInfo.workstationNumber,
                        [],
                        presentCount,
                        absentCount,
                        workFromHomeCount,
                        leaveCount,
                        unitNameMap.get(empInfo.unitId),
                        otHoursInfoMap.get(empInfo.employeeCode),
                        otShiftInfoMap.get(empInfo.employeeCode),
                        weekOffCount,
                        publicHolidayCount,
                        notOutPunchCount,
                        totalDaysCount,
                        totalPresentDays,
                        payableDays,
                        record.weekOffDay,
                        compOffCount,
                        outDoorCount
                    ));
                }


                empAttenResponseMap.get(empInfo.employeeId).dayStatus.push(new DayStatusModel(record.day, record.present_status, record.date));
            }
            const monthModelArray: MonthAttnDataModel[] = [];
            empAttenResponseMap.forEach(empAttn => monthModelArray.push(empAttn));
            if (monthModelArray) {
                return new MonthAttendanceResponse(true, 0, 'Retrieved successfully', monthModelArray);
            } else {
                return new MonthAttendanceResponse(false, 0, 'Error in getting data');
            }
        } catch (err) {
            return err;
        }
    }

    async getDepartmentDropForAttReport(req: UnitRequest): Promise<CommonResponse> {

        return new CommonResponse(true, 44545, 'Retrieved successfully')
    }

    async getAllEmpDateAtten(req: EmployeeAttDateRequest): Promise<AttendanceResponse> {
        try {
            const attenDtos: AttendanceModel[] = [];
            let empEntities: AttendanceEntity[] = [];
            const empInfo = await this.attendanceHelperService.getAllEmployees();
            const empNameMap = new Map<number, string>();
            empInfo.forEach(emp => empNameMap.set(emp.employeeId, emp.reportingManager));
            const contNameMap = new Map<number, string>();
            empInfo.forEach(emp => contNameMap.set(emp.employeeId, emp.contractorName));
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const unitInfo = await this.unitCodeService.getAllActiveUnitcode();
            const unitNameMap = new Map<number, string>();
            unitInfo.data.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));
            if (req.employeeCode) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode } });
            } else if (req.departmentId && req.employeeCode) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId } });
            } else if (req.departmentId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), departmentId: req.departmentId } });
            } else if (req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), unitId: req.unitId } });
            } else if (req.shift) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), shift: req.shift } });
            } else if (req.shift && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), shift: req.shift, unitId: req.unitId } });
            } else if (req.departmentId && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), departmentId: req.departmentId, unitId: req.unitId } });
            } else if (req.departmentId && req.employeeCode && req.shift) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId, shift: req.shift } });
            } else if (req.departmentId && req.employeeCode && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId, unitId: req.unitId } });
            } else if (req.departmentId && req.employeeCode && req.shift && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId, shift: req.shift, unitId: req.unitId } });
            } else {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate) } });
            }
            if (empEntities) {
                empEntities.forEach(Entity => {
                    const convertedEntity: AttendanceModel = this.AttendanceAdapter.convertEntityToDto(Entity);
                    convertedEntity.departmentCode = deptNameMap.get(convertedEntity.departmentId);
                    convertedEntity.reportingManager = empNameMap.get(convertedEntity.employeeId);
                    convertedEntity.unitId = unitNameMap.get(convertedEntity.unitId);
                    convertedEntity.contractorName = contNameMap.get(convertedEntity.employeeId) ? contNameMap.get(convertedEntity.employeeId) : null;
                    convertedEntity.workingHours = convertedEntity.outTime ? moment.utc(moment(convertedEntity.outTime).diff(moment(convertedEntity.inTime))).format('HH:mm') : null;
                    attenDtos.push(convertedEntity);
                });
                return new AttendanceResponse(true, 11108, 'Employees Data Retrieved Successfully', attenDtos);
            } else {
                return new AttendanceResponse(false, 11101, 'Data Not Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAdjustmentData(req: AttendanceAdjustRequest): Promise<AttendanceAdjustResponse> {
        try {
            if (req.employeeCode) {
                const attEntity = await this.attendanceRepo.findOne({ where: { employeeCode: req.employeeCode, date: req.date } });
                if (attEntity) {
                    const convertedEntity: AttendanceModel = this.AttendanceAdapter.convertEntityToDto(attEntity);
                    return new AttendanceAdjustResponse(true, 11108, 'Active Employees retrived', convertedEntity);
                } else {
                    return new AttendanceAdjustResponse(false, 99998, 'Data Not Found')
                }
            }
        } catch (err) {
            return err;
        }
    }

    async getPresentEmployeesData(req: DateReq): Promise<AttendanceResponse> {
        const date = req.date
        const attnModel: AttendanceModel[] = [];
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        const attEntities = await this.attendanceRepo.find({ where: { presentStatus: "P", date: date }, order: { employeeCode: 'ASC' } });
        if (attEntities) {
            for (const attnEntity of attEntities) {
                const convertedEntity: AttendanceModel = this.AttendanceAdapter.convertEntityToDto(attnEntity);
                convertedEntity.departmentCode = deptNameMap.get(convertedEntity.departmentId)
                attnModel.push(convertedEntity);
            }
            return new AttendanceResponse(true, 11108, 'Active Employees retrived', attnModel);
        } else {
            return new AttendanceResponse(false, 99998, 'Data Not Found')
        }
    }

    async getPresentEmployeeDataByEmpCode(req: AttendanceAdjustRequest): Promise<AttendanceResponse> {
        const date = req.date;
        const empCode = req.employeeCode;
        const record = await this.attendanceRepo.getEmpAttenRecordByDateEmpCode(date, empCode);
        const attnModel = new AttendanceModel(record.employee_id, record.employee_code, record.employee_name, date, record.in_time, record.out_time);
        return new AttendanceResponse(true, 11101, 'retrived successfully', [attnModel]);
    }

    async getLessWorkingEmployees(): Promise<AttendanceResponse> {

        function getPreviousDay(date = new Date()) {
            const previous = new Date(date.getTime());
            previous.setDate(date.getDate() - 1);
            return previous;
        }
        const ystDate = getPreviousDay();
        const toDate = ystDate.getFullYear() + '-' + (ystDate.getMonth() + 1) + '-' + ystDate.getDate();
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
        const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
        let monthStartDate = '';
        if (currDate.getDate() == 1) {
            monthStartDate = currDate.getFullYear() + '-' + currDate.getMonth() + '-' + '1';
        } else {
            monthStartDate = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + '1';
        }
        const record = await this.attendanceRepo.getTotalLessWorkingHoursData(monthStartDate, toDate);
        return new AttendanceResponse(true, 11101, 'retrived successfully', record);
    }

    async getCriteriaNotMatchingReport(): Promise<AttendanceResponse> {

        function getPreviousDay(date = new Date()) {
            const previous = new Date(date.getTime());
            previous.setDate(date.getDate() - 1);
            return previous;
        }
        const ystDate = getPreviousDay();
        const toDate = ystDate.getFullYear() + '-' + (ystDate.getMonth() + 1) + '-' + ystDate.getDate();
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
        const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
        let monthStartDate = '';
        if (currDate.getDate() == 1) {
            monthStartDate = currDate.getFullYear() + '-' + currDate.getMonth() + '-' + '1';
        } else {
            monthStartDate = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + '1';
        }
        const record = await this.attendanceRepo.getCriteriaNotMatchingData(monthStartDate, toDate);
        return new AttendanceResponse(true, 11101, 'retrived successfully', record);
    }

    async updateAttendanceByHR(attnUpdateReq: AttendanceUpdateRequest): Promise<AttendanceResponse> {
        const date = attnUpdateReq.date;
        const empCode = attnUpdateReq.employeeCode;
        const currDate = new Date();
        const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
        if (empRecord) {
            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: attnUpdateReq.presentStatus, reason: attnUpdateReq.reason, hrStatus: true, updatedUser: attnUpdateReq.user });
            return new AttendanceResponse(true, 11101, 'Attendance updated successfully');
        } else {
            return new AttendanceResponse(false, 11106, 'Record not found for this Employee');
        }
    }

    async getUnitDropForAttReport(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT uc.unit_name AS unitName , a.unit_id AS unitId FROM ` + appSettings.hrms_db + `.attendance a 
          LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.unit_id 
          WHERE a.employee_id > 0 AND a.unit_id > 0 GROUP BY a.unit_id `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 1121, 'Data retrived succesfully', data)
        }
        else {
            return new CommonResponse(false, 1121, 'No data found')
        }
    }

    async getShiftDropForAttReport(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT shift AS shift FROM ` + appSettings.hrms_db + `.attendance
          WHERE shift > '' GROUP BY shift `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 1121, 'Data retrived succesfully', data)
        }
        else {
            return new CommonResponse(false, 1121, 'No data found')
        }
    }

    // @Cron('0 */8 * * *')
    async updateAttendanceStatus() {
        try {
            // Update status for employees working less than 3 hours for worker
            await this.attendanceRepo.query(
                `UPDATE erpx_dev_hrms.attendance a 
                JOIN erpx_dev_masters.employee_details e ON a.employee_code = e.employee_code
                JOIN erpx_dev_hrms.consolidated_attendance_log c ON c.employee_code = a.employee_code AND c.log_date = a.date
                SET a.present_status = CASE
                    WHEN a.present_status = 'WP' THEN 'WO'
                    WHEN a.present_status = 'P' THEN 'A'
                    WHEN a.present_status = 'PHP' THEN 'PH'
                    ELSE 'A'
                END
                WHERE e.employee_type = 'Labour Form'
                  AND TIME_TO_SEC(c.total_hours) / 3600 <= 3
                  AND a.date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY `
            )
            // Update status for employees working less than 3 hours for salary form
            await this.attendanceRepo.query(
                `UPDATE erpx_dev_hrms.attendance a 
                JOIN erpx_dev_masters.employee_details e ON a.employee_code = e.employee_code
                SET a.present_status = CASE
                    WHEN a.present_status = 'WP' THEN 'WO'
                    WHEN a.present_status = 'P' THEN 'A'
                    WHEN a.present_status = 'PHP' THEN 'PH'
                    ELSE 'A'
                END
                WHERE e.employee_type = 'Salaried Form'
                  AND TIMESTAMPDIFF(HOUR, a.in_time, a.out_time) <= 3
                  AND a.date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY `
            )
            await this.attendanceRepo.query(`
                UPDATE erpx_dev_hrms.attendance a
                JOIN erpx_dev_masters.employee_details e ON a.employee_code = e.employee_code
                JOIN erpx_dev_hrms.consolidated_attendance_log c ON c.employee_code = a.employee_code AND c.log_date = a.date
                SET a.present_status = CASE
                    WHEN a.present_status = 'WP' THEN 'WP/2'
                    WHEN a.present_status = 'P' THEN 'P/2'
                    WHEN a.present_status = 'PHP' THEN 'PHP/2'
                    ELSE 'P/2'
                END
                WHERE e.employee_type = 'Labour Form'
                  AND TIME_TO_SEC(c.total_hours) / 3600 >= 3
                  AND TIME_TO_SEC(c.total_hours) / 3600 <= 6
                  AND a.date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY
            `);

            // Update status for employees working between 3 to 6 hours and Salaried Form type
            await this.attendanceRepo.query(`
                UPDATE erpx_dev_hrms.attendance a
                JOIN erpx_dev_masters.employee_details e ON a.employee_code = e.employee_code
                SET a.Present_status = CASE
                    WHEN a.Present_status = 'WP' THEN 'WP/2'
                    WHEN a.Present_status = 'P' THEN 'P/2'
                    WHEN a.Present_status = 'PHP' THEN 'PHP/2'
                    WHEN a.Present_status = 'P/2' THEN 'P/2'
                    WHEN a.Present_status = 'P/L' THEN 'P/L'
                    WHEN a.Present_status = 'P/CO' THEN 'P/CO'
                    WHEN a.Present_status = 'P/OD' THEN 'P/OD'
                    ELSE 'P/2'
                END
                WHERE e.employee_type = 'Salaried Form'
                  AND TIMESTAMPDIFF(HOUR, a.in_time, a.out_time) BETWEEN 3 AND 6
                  AND a.date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY;
            `);

            // Update status for Salaried Form employees working 6 hours or more
            await this.attendanceRepo.query(`
                UPDATE erpx_dev_hrms.attendance a
                JOIN erpx_dev_masters.employee_details e ON a.employee_code = e.employee_code
                SET a.present_status = CASE 
                    WHEN a.present_status = 'WP' THEN 'WP'
                    WHEN a.present_status = 'P' THEN 'P'
                    WHEN a.present_status = 'PHP' THEN 'PHP'
                    WHEN a.present_status = 'WP/2' THEN 'WP'
                    WHEN a.present_status = 'P/2' THEN 'P'
                    WHEN a.present_status = 'PHP/2' THEN 'PHP'
                    ELSE 'P'
                END
                WHERE e.employee_type = 'Salaried Form'
                  AND TIMESTAMPDIFF(HOUR, a.in_time, a.out_time) >= 6
                  AND a.date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY
            `);

            // Update status for Labour Form employees working more than 6 hours
            await this.attendanceRepo.query(`
                UPDATE erpx_dev_hrms.attendance a
                JOIN erpx_dev_masters.employee_details e ON a.employee_code = e.employee_code
                JOIN erpx_dev_hrms.consolidated_attendance_log c ON c.employee_code = a.employee_code AND c.log_date = a.date
                SET a.present_status = CASE
                    WHEN a.present_status = 'WP' THEN 'WP'
                    WHEN a.present_status = 'P' THEN 'P'
                    WHEN a.present_status = 'PHP' THEN 'PHP'
                    WHEN a.present_status = 'WP/2' THEN 'WP'
                    WHEN a.present_status = 'P/2' THEN 'P'
                    WHEN a.present_status = 'PHP/2' THEN 'PHP'
                    ELSE 'P'
                END
                WHERE e.employee_type = 'Labour Form'
                  AND TIME_TO_SEC(c.total_hours) / 3600 > 6
                  AND a.date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY
            `);

            // Update present status for employees with specific hours range (14 to 16 hours)
            await this.attendanceRepo
                .createQueryBuilder()
                .update(AttendanceEntity)
                .set({
                    presentStatus: () => `
                        CASE 
                            WHEN present_status = 'WP' THEN 'WPP'
                            WHEN present_status = 'P' THEN 'PP'
                            WHEN present_status = 'PHP' THEN 'PHPP'
                            ELSE present_status
                        END`
                })
                .where('TIMESTAMPDIFF(HOUR, inTime, outTime) >= 14')
                .andWhere('TIMESTAMPDIFF(HOUR, inTime, outTime) <= 16')
                .andWhere('date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY')
                .execute();

            // Update punch status and shift based on out_time
            await this.attendanceRepo
                .createQueryBuilder()
                .update(AttendanceEntity)
                .set({
                    punchStatus: "NIP",
                    presentStatus: () => `
                        CASE 
                            WHEN present_status = 'WO' THEN 'WNIP'
                            WHEN present_status = 'A' THEN 'P'
                            WHEN present_status = 'PH' THEN 'PHNIP'
                            ELSE present_status
                        END`,
                    shift: () => `
                        CASE 
                            WHEN TIME(out_time) BETWEEN TIME('12:00:00') AND TIME('14:29:59') THEN 'A'
                            WHEN TIME(out_time) BETWEEN TIME('21:00:00') AND TIME('22:30:00') THEN 'B'
                            WHEN TIME(out_time) BETWEEN TIME('04:30:00') AND TIME('06:29:59') THEN 'C'
                            WHEN TIME(out_time) BETWEEN TIME('16:30:00') AND TIME('18:40:59') THEN 'G'
                            WHEN TIME(out_time) BETWEEN TIME('01:00:00') AND TIME('03:30:59') THEN 'D'
                            ELSE NULL
                        END`
                })
                .where("in_time IS NULL AND out_time IS NOT NULL")
                .andWhere('date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY')
                .execute();

            // Update punch status when in_time is present but out_time is not
            await this.attendanceRepo
                .createQueryBuilder()
                .update(AttendanceEntity)
                .set({
                    punchStatus: "NOP",
                    presentStatus: () => `
                        CASE 
                            WHEN present_status = 'WP' THEN 'WNOP'
                            WHEN present_status = 'P' THEN 'P'
                            WHEN present_status = 'PHP' THEN 'PHNOP'
                            ELSE present_status
                        END`
                })
                .where("in_time IS NOT NULL AND out_time IS NULL")
                .andWhere('date BETWEEN CURDATE() - INTERVAL 46 DAY AND CURDATE() - INTERVAL 1 DAY')
                .execute();

            return { success: true, message: 'Attendance statuses updated successfully' };
        } catch (error) {
            return { success: false, message: 'Failed to update attendance statuses' };
        }
    }


    async getEmployeeWorkingHrs(req?: any): Promise<CommonResponse> {
        const data = await this.consolidatedAttendanceLogRepo.getEmployeeWorkingHrs(req)
        if (data.length > 0)
            return new CommonResponse(true, 1, 'data retrived', data)
        else
            return new CommonResponse(false, 0, 'No data found');
    }




    async getWorkerMonthWiseAttendanceReport(monthReq: AttendanceMonthRequest): Promise<MonthAttendanceResponse> {
        // console.log(monthReq, 'monthReqmo;;;;;;;;;;;;;;nthReq')
        try {
            const year = monthReq.year
            const month = monthReq.month;
            const deptId = monthReq.departmentId;
            const unitId = monthReq.unitId;
            const category = monthReq.category
            const empAttenResponseMap = new Map<number, MonthAttnDataModel>();
            const records = await this.attendanceRepo.getWorkerAttendanceRecordsByMonth(year, month, deptId, unitId, category);
            if (records.length == 0) {
                return new MonthAttendanceResponse(false, 0, 'No data found');
            }
            const unitInfo = await this.attendanceHelperService.getAllUnitcodes();
            const unitNameMap = new Map<number, string>();
            unitInfo.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const empsInfo = await this.attendanceHelperService.getAllEmployees();
            const empsInfoMap = new Map<number, EmployeeDto>();
            empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
            // const otHoursInfo = await this.overTimeService.getOTHoursByEmployeeCode(monthReq);
            // const otHoursInfoMap = new Map<string, number>();
            // otHoursInfo.data.forEach(emp => otHoursInfoMap.set(emp.employeeCode, emp.otHours));
            // const otShiftInfo = await this.overTimeService.getOTShiftsByEmployeeCode(monthReq);
            // const otShiftInfoMap = new Map<string, number>();
            // otShiftInfo.data.forEach(emp => otShiftInfoMap.set(emp.employeeCode, emp.otShifts));
            for (const record of records) {
                const empId = Number(record.employee_id);
                const empInfo = empsInfoMap.get(empId);
                if (!empAttenResponseMap.has(empInfo.employeeId)) {
                    const empRecords = await this.attendanceRepo.getWorkerMonthRecordsForEmp(year, empInfo.employeeId, month);
                    // console.log(empRecords,'-----------')
                    // console.log(records,'records')
                    let presentCount = 0;
                    // let outDoorCount = 0;
                    // let workFromHomeCount = 0;
                    let weekOffCount = 0;
                    let wpCount = 0;
                    let publicHolidayCount = 0;
                    let phpCount = 0;
                    let notOutPunchCount = 0;
                    let totalDaysCount = 0;
                    // let totalPresentDays = 0;
                    let payableDays = 0;
                    let absentCount = 0;
                    let monthDays = 0
                    const daysInMonth = {
                        1: 31,
                        2: new Date(year, 1, 29).getMonth() === 1 ? 29 : 28,
                        3: 31,
                        4: 30,
                        5: 31,
                        6: 30,
                        7: 31,
                        8: 31,
                        9: 30,
                        10: 31,
                        11: 30,
                        12: 31
                    };

                    // monthDays = daysInMonth[month];
                    // const startDate: any = new Date(year, month - 2, 27);
                    // const endDate: any = new Date(year, month - 1, 26);

                    // const daysCount = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;

                    for (const empRecord of empRecords) {
                        const status = empRecord.present_status;
                        const count = Number(empRecord.count);
                        // console.log(status, ':', count)
                        if (['P', 'P/2'].includes(status)) {
                            if (status === 'P') {
                                presentCount += count;
                            } else if (['P/2'].includes(status)) {
                                presentCount += count * 0.5;
                                absentCount += count * 0.5;
                            }

                        } else if (['WO'].includes(status)) {
                            weekOffCount += count;
                        } else if (['WP', 'WP/2', 'WNOP', 'WNIP'].includes(status)) {
                            wpCount += count;
                        } else if (['PH'].includes(status)) {
                            publicHolidayCount += count;
                        } else if (['PHP'].includes(status)) {
                            phpCount += count;
                        } else if (['NOP', 'NIP'].includes(status)) {
                            notOutPunchCount += count;
                        } else if (status === 'A') {
                            absentCount += count;
                        }
                    }
                    totalDaysCount = presentCount + wpCount + phpCount + weekOffCount + publicHolidayCount

                    // if (totalDaysCount === daysCount) {
                    //     payableDays = monthDays;
                    // } else {
                    //     payableDays = monthDays - (daysCount - totalDaysCount)
                    // }

                    empAttenResponseMap.set(empInfo.employeeId, new MonthAttnDataModel(
                        empInfo.employeeCode,
                        `${empInfo.employeeName} ${empInfo.employeeLastName}`,
                        deptNameMap.get(record.department_id),
                        empInfo.contractorName,
                        record.shift,
                        empInfo.workstationNumber,
                        [],
                        presentCount,
                        absentCount,
                        wpCount,
                        phpCount,
                        unitNameMap.get(empInfo.unitId),
                        undefined,
                        undefined,
                        weekOffCount,
                        publicHolidayCount,
                        notOutPunchCount,
                        totalDaysCount,
                        undefined,
                        payableDays,
                        record.weekOffDay
                    ));
                }


                empAttenResponseMap.get(empInfo.employeeId).dayStatus.push(new DayStatusModel(record.day, record.present_status, record.date));
            }
            const monthModelArray: MonthAttnDataModel[] = [];
            empAttenResponseMap.forEach(empAttn => monthModelArray.push(empAttn));
            if (monthModelArray) {
                return new MonthAttendanceResponse(true, 0, 'Retrieved successfully', monthModelArray);
            } else {
                return new MonthAttendanceResponse(false, 0, 'Error in getting data');
            }
        } catch (err) {
            return err;
        }
    }


    async getWorkerIncentiveReport(monthReq: AttendanceMonthRequest): Promise<CommonResponse> {
        // console.log(monthReq, 'monthReqmonthReq')
        try {
            const year = monthReq.year
            const month = monthReq.month;
            const deptId = monthReq.departmentId;
            const unitId = monthReq.unitId;
            const category = monthReq.category;
            const empAttenResponseMap = new Map<number, WorkingHrModel>();
            const records = await this.attendanceRepo.getWorkersIncentiveHrsByMonth(year, month, deptId, unitId, category);
            if (records.length == 0) {
                return new CommonResponse(false, 0, 'No data found');
            }
            const unitInfo = await this.attendanceHelperService.getAllUnitcodes();
            const unitNameMap = new Map<number, string>();
            unitInfo.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));

            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));

            const empsInfo = await this.attendanceHelperService.getAllEmployees();
            const empsInfoMap = new Map<number, EmployeeDto>();
            empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));

            const otHoursInfo = await this.overTimeService.getOTHoursByEmployeeCode(monthReq);
            const otHoursInfoMap = new Map<string, number>();
            otHoursInfo.data.forEach(emp => otHoursInfoMap.set(emp.employeeCode, emp.otHours));

            const otShiftInfo = await this.overTimeService.getOTShiftsByEmployeeCode(monthReq);
            const otShiftInfoMap = new Map<string, number>();
            otShiftInfo.data.forEach(emp => otShiftInfoMap.set(emp.employeeCode, emp.otShifts));

            function convertToDecimalHours(time: string): number {
                const [hours, minutes] = time.split(':').map(Number);
                return hours + (minutes / 60);
            }

            function convertDecimalToHoursMinutes(decimalHours: number): string {
                const hours = Math.floor(decimalHours);
                const minutes = Math.round((decimalHours - hours) * 60);
                return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
            }
            for (const record of records) {
                // console.log(record, 'record')
                const empId = Number(record.employee_id);
                const empInfo = empsInfoMap.get(empId);
                if (!empInfo) continue;

                if (!empAttenResponseMap.has(empInfo.employeeId)) {
                    const empRecords = records.filter(empRecord => Number(empRecord.employee_id) === empId);
                    // console.log('Employee Records:', empRecords);

                    let totalAllIncentiveHrs = 0;
                    for (const empRecord of empRecords) {
                        const hours = convertToDecimalHours(empRecord.totalHours || '0:00');
                        let incentiveHours = 0;
                        if (empRecord.presentStatus === 'P' && hours > 8) {
                            incentiveHours = hours - 8;
                        } else if (empRecord.presentStatus === 'WP' || empRecord.presentStatus === 'PHP') {
                            incentiveHours = hours;
                        }
                        totalAllIncentiveHrs += incentiveHours;
                    }
                    const totalIncentiveHrsFormatted = convertDecimalToHoursMinutes(totalAllIncentiveHrs);
                    // console.log('Total Incentive Hours Formatted:', totalIncentiveHrsFormatted);
                    empAttenResponseMap.set(empInfo.employeeId, new WorkingHrModel(
                        empInfo.employeeCode,
                        `${empInfo.employeeName} ${empInfo.employeeLastName}`,
                        deptNameMap.get(record.department_id),
                        empInfo.contractorName,
                        record.shift,
                        empInfo.workstationNumber,
                        [],
                        totalIncentiveHrsFormatted
                    ));
                }
                let recordIncentiveHours = 0;
                const recordHours = convertToDecimalHours(record.totalHours || '0:00');
                if (record.presentStatus === 'P' && recordHours > 8) {
                    recordIncentiveHours = recordHours - 8;
                } else if (record.presentStatus === 'WP' || record.presentStatus === 'PHP') {
                    recordIncentiveHours = recordHours;
                }
                const incentiveHoursFormatted = convertDecimalToHoursMinutes(recordIncentiveHours);
                // console.log(incentiveHoursFormatted, 'incentiveHoursFormatted')
                empAttenResponseMap.get(empInfo.employeeId).dayStatus.push(new DayStatusModel(record.day, record.presentStatus, record.date, incentiveHoursFormatted));
            }
            const monthModelArray: WorkingHrModel[] = [];
            empAttenResponseMap.forEach(empAttn => monthModelArray.push(empAttn));
            if (monthModelArray) {
                return new CommonResponse(true, 0, 'Retrieved successfully', monthModelArray);
            } else {
                return new CommonResponse(false, 0, 'Error in getting data');
            }
        } catch (err) {
            return err;
        }
    }

    async getWorkerNmrIncentiveReport(monthReq: AttendanceMonthRequest): Promise<CommonResponse> {
        // console.log(monthReq, 'monthReqmonthReq')
        try {
            const year = monthReq.year
            const month = monthReq.month;
            const deptId = monthReq.departmentId;
            const unitId = monthReq.unitId;
            // const category = monthReq.category;
            const empAttenResponseMap = new Map<number, WorkingHrModel>();
            const records = await this.attendanceRepo.getNMRIncentiveHrsByMonth(year, month, deptId, unitId);
            if (records.length == 0) {
                return new CommonResponse(false, 0, 'No data found');
            }
            const unitInfo = await this.attendanceHelperService.getAllUnitcodes();
            const unitNameMap = new Map<number, string>();
            unitInfo.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));

            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));

            const empsInfo = await this.attendanceHelperService.getAllEmployees();
            const empsInfoMap = new Map<number, EmployeeDto>();
            empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));

            const otHoursInfo = await this.overTimeService.getOTHoursByEmployeeCode(monthReq);
            const otHoursInfoMap = new Map<string, number>();
            otHoursInfo.data.forEach(emp => otHoursInfoMap.set(emp.employeeCode, emp.otHours));

            const otShiftInfo = await this.overTimeService.getOTShiftsByEmployeeCode(monthReq);
            const otShiftInfoMap = new Map<string, number>();
            otShiftInfo.data.forEach(emp => otShiftInfoMap.set(emp.employeeCode, emp.otShifts));

            function convertToDecimalHours(time: string): number {
                const [hours, minutes] = time.split(':').map(Number);
                return hours + (minutes / 60);
            }

            function convertDecimalToHoursMinutes(decimalHours: number): string {
                const hours = Math.floor(decimalHours);
                const minutes = Math.round((decimalHours - hours) * 60);
                return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
            }
            for (const record of records) {
                // console.log(record, 'record')
                const empId = Number(record.employee_id);
                const empInfo = empsInfoMap.get(empId);
                if (!empInfo) continue;

                if (!empAttenResponseMap.has(empInfo.employeeId)) {
                    const empRecords = records.filter(empRecord => Number(empRecord.employee_id) === empId);
                    // console.log('Employee Records:', empRecords);

                    let totalAllIncentiveHrs = 0;
                    for (const empRecord of empRecords) {
                        const hours = convertToDecimalHours(empRecord.totalHours || '0:00');
                        let incentiveHours = 0;
                        if (empRecord.presentStatus === 'P' && hours > 8) {
                            incentiveHours = hours - 8;
                        } else
                            if (empRecord.presentStatus === 'WP' || empRecord.presentStatus === 'PHP') {
                                incentiveHours = hours;
                            }
                        totalAllIncentiveHrs += incentiveHours;
                    }
                    const totalIncentiveHrsFormatted = convertDecimalToHoursMinutes(totalAllIncentiveHrs);
                    // console.log('Total Incentive Hours Formatted:', totalIncentiveHrsFormatted);
                    empAttenResponseMap.set(empInfo.employeeId, new WorkingHrModel(
                        empInfo.employeeCode,
                        `${empInfo.employeeName} ${empInfo.employeeLastName}`,
                        deptNameMap.get(record.department_id),
                        empInfo.contractorName,
                        record.shift,
                        empInfo.workstationNumber,
                        [],
                        totalIncentiveHrsFormatted
                    ));
                }
                let recordIncentiveHours = 0;
                const recordHours = convertToDecimalHours(record.totalHours || '0:00');
                if (record.presentStatus === 'P' && recordHours > 8) {
                    recordIncentiveHours = recordHours - 8;
                } else
                    if (record.presentStatus === 'WP' || record.presentStatus === 'PHP') {
                        recordIncentiveHours = recordHours;
                    }
                const incentiveHoursFormatted = convertDecimalToHoursMinutes(recordIncentiveHours);
                // console.log(incentiveHoursFormatted, 'incentiveHoursFormatted')
                empAttenResponseMap.get(empInfo.employeeId).dayStatus.push(new DayStatusModel(record.day, record.presentStatus, record.date, incentiveHoursFormatted));
            }
            const monthModelArray: WorkingHrModel[] = [];
            empAttenResponseMap.forEach(empAttn => monthModelArray.push(empAttn));
            if (monthModelArray) {
                return new CommonResponse(true, 0, 'Retrieved successfully', monthModelArray);
            } else {
                return new CommonResponse(false, 0, 'Error in getting data');
            }
        } catch (err) {
            return err;
        }
    }

    async getLateAndEarlyEntryEmployees(req: ShiftAttendanceRequest): Promise<CommonResponse> {
        // console.log(req, "req")
        try {
            const manager = getManager();
            let query = `SELECT ed.employee_id, a.employee_code AS employeeCode, a.employee_name AS employeeName, a.shift, a.present_status, a.date AS attendanceDate, a.in_time AS inTime, a.out_time AS outTime, c.total_hours, ed.employee_type,
        CASE 
            WHEN 
                (a.shift = 'A' AND TIME(a.in_time) > '06:15:00') OR
                (a.shift = 'B' AND TIME(a.in_time) > '14:15:00') OR
                (a.shift = 'G' AND TIME(a.in_time) > '09:15:00') OR
                (a.shift = 'C' AND TIME(a.in_time) > '21:15:00') OR
                (a.shift = 'D' AND TIME(a.in_time) > '18:15:00') 
            THEN 'Yes' 
            ELSE 'No' 
        END AS lateEntry,
        CASE 
            WHEN 
                (a.shift = 'A' AND TIME(a.out_time) < '13:45:00') OR
                (a.shift = 'B' AND TIME(a.out_time) < '20:45:00') OR
                (a.shift = 'G' AND TIME(a.out_time) < '17:45:00') OR
                (a.shift = 'C' AND TIME(a.out_time) < '05:45:00') OR
                (a.shift = 'D' AND TIME(a.out_time) < '02:45:00')
            THEN 'Yes' 
            ELSE 'No' 
        END AS earlyExit FROM `+ appSettings.hrms_db + `.attendance a 
        LEFT JOIN `+ appSettings.hrms_db + `.consolidated_attendance_log c ON c.employee_code = a.employee_code 
        AND c.log_date = a.date
        LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_code = a.employee_code
        WHERE ed.employee_type = 'Salaried Form'`;
            if (req.fromDate != undefined) {
                query = query + ' and date(a.date) >= "' + req.fromDate + '" and  date(a.date) <= "' + req.toDate + '"';
            }
            if (req.employeeId) {
                query += ` AND ed.employee_id = '${req.employeeId}'`;
            }
            query += ` ORDER BY a.date`;
            const data = await manager.query(query)
            if (data.length > 0) {
                const response = new CommonResponse(true, 11208, "Report retrieved successfully", data);
                return response;
            } else {
                throw new CommonResponse(false, 99998, 'No Record Found');
            }
        } catch (err) {
            throw err
        }


    }
    // @Cron('40 22 * * *')
    async updateWOAttendanceStatus(req: any): Promise<CommonResponse> {
        try {
            const result = await this.attendanceRepo.query(` UPDATE attendance a
                JOIN (
                  SELECT wo.employee_code, wo.date AS wo_date,
                         SUM(CASE WHEN a1.present_status = 'P' THEN 1 ELSE 0 END) AS presence_count
                  FROM attendance wo
                  LEFT JOIN attendance a1
                  ON wo.employee_code = a1.employee_code
                  AND a1.date BETWEEN DATE_SUB(wo.date, INTERVAL 6 DAY) AND DATE_SUB(wo.date, INTERVAL 1 DAY)
                  WHERE wo.present_status = 'WO'
                  GROUP BY wo.employee_code, wo.date
                ) AS wo_records
                ON a.employee_code = wo_records.employee_code
                AND a.date = wo_records.wo_date
                SET a.present_status = CASE 
                    WHEN wo_records.presence_count < 3 THEN 'A'
                    ELSE a.present_status
                END
                WHERE a.present_status = 'WO'`);

            // Assuming `result` is an array or has a property `affectedRows` indicating rows updated
            if (result.affectedRows > 0) {
                return new CommonResponse(true, 11208, 'Attendance status updated successfully');
            } else {
                throw new CommonResponse(false, 99998, 'No Record Found');
            }
        } catch (err) {
            throw err
        }
    }

    // @Cron('30 22 * * *')
    async updatePHAttendanceStatus(req: any): Promise<CommonResponse> {
        try {
            const result = await this.attendanceRepo.query(` UPDATE attendance a
                JOIN (
                  SELECT ph.employee_code, ph.date AS ph_date,
                         SUM(CASE WHEN a1.present_status = 'A' THEN 1 ELSE 0 END) AS absence_count,
                         COUNT(a1.present_status) AS total_count
                  FROM attendance ph
                  LEFT JOIN attendance a1
                  ON ph.employee_code = a1.employee_code
                  AND a1.date BETWEEN DATE_SUB(ph.date, INTERVAL 2 DAY) AND DATE_ADD(ph.date, INTERVAL 2 DAY)
                  AND a1.date <> ph.date
                  WHERE ph.present_status = 'PH'
                  GROUP BY ph.employee_code, ph.date
                ) AS ph_records
                ON a.employee_code = ph_records.employee_code
                AND a.date = ph_records.ph_date
                SET a.present_status = CASE 
                    WHEN ph_records.absence_count = ph_records.total_count THEN 'A'
                    ELSE a.present_status
                END
                WHERE a.present_status = 'PH' `);

            // Assuming `result` is an array or has a property `affectedRows` indicating rows updated
            if (result.affectedRows > 0) {
                return new CommonResponse(true, 11208, 'Attendance status updated successfully');
            } else {
                throw new CommonResponse(false, 99998, 'No Record Found');
            }
        } catch (err) {
            throw err
        }
    }

    async getNmrMonthWiseAttendanceReport(monthReq: AttendanceMonthRequest): Promise<MonthAttendanceResponse> {
        // console.log(monthReq, 'monthReqmonthReq')
        try {
            const year = monthReq.year
            const month = monthReq.month;
            const deptId = monthReq.departmentId;
            const unitId = monthReq.unitId;
            const category = monthReq.category
            const empAttenResponseMap = new Map<number, MonthAttnDataModel>();
            const records = await this.attendanceRepo.getNmrAttendanceRecordsByMonth(year, month, deptId, unitId, category);
            if (records.length == 0) {
                return new MonthAttendanceResponse(false, 0, 'No data found');
            }
            const unitInfo = await this.attendanceHelperService.getAllUnitcodes();
            console.log(unitInfo,'unitinfo',unitInfo.length)
            const unitNameMap = new Map<number, string>();
            unitInfo.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            console.log(deptInfo,'deptInfo',deptInfo.length)
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const empsInfo = await this.attendanceHelperService.getAllEmployees();
            const empsInfoMap = new Map<number, EmployeeDto>();
            console.log(empsInfo,'empsInfo',empsInfo.length)
            empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
            // const otHoursInfo = await this.overTimeService.getOTHoursByEmployeeCode(monthReq);
            // const otHoursInfoMap = new Map<string, number>();
            // otHoursInfo.data.forEach(emp => otHoursInfoMap.set(emp.employeeCode, emp.otHours));
            // const otShiftInfo = await this.overTimeService.getOTShiftsByEmployeeCode(monthReq);
            // const otShiftInfoMap = new Map<string, number>();
            // otShiftInfo.data.forEach(emp => otShiftInfoMap.set(emp.employeeCode, emp.otShifts));
            for (const record of records) {
                const empId = Number(record.employee_id);
                const empInfo = empsInfoMap.get(empId);
                if (!empAttenResponseMap.has(empInfo.employeeId)) {
                    const empRecords = await this.attendanceRepo.getNmrMonthRecordsForEmp(year, empInfo.employeeId, month);
                    let presentCount = 0;
                    let outDoorCount = 0;
                    let absentCount = 0;
                    let workFromHomeCount = 0;
                    let leaveCount = 0;
                    let weekOffCount = 0;
                    let publicHolidayCount = 0;
                    let notOutPunchCount = 0;
                    let totalDaysCount = 0;
                    let totalPresentDays = 0; // Initialize totalPresentDays
                    let payableDays = 0; // Initialize payableDays
                    let monthDays = 0
                    const daysInMonth = {
                        1: 31,
                        2: new Date(year, 1, 29).getMonth() === 1 ? 29 : 28,
                        3: 31,
                        4: 30,
                        5: 31,
                        6: 30,
                        7: 31,
                        8: 31,
                        9: 30,
                        10: 31,
                        11: 30,
                        12: 31
                    };

                    monthDays = daysInMonth[month];
                    const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
                    const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];

                    const daysCount = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;


                    for (const empRecord of empRecords) {
                        const status = empRecord.present_status;
                        const count = Number(empRecord.count);
                        // console.log(status, ':', count)
                        if (['P', 'P/CO', 'P/L', 'P/OD', 'P/2'].includes(status)) {
                            if (status === 'P') {
                                presentCount += count;
                            } else if (['P/CO', 'P/L'].includes(status)) {
                                presentCount += count * 0.5;
                            } else if (status === 'P/2') {
                                presentCount += count * 0.5;
                                absentCount += count * 0.5;
                            } else if (status === 'P/OD') {
                                presentCount += count * 0.5;
                                outDoorCount += count * 0.5;
                            }

                        } else if (['WO', 'WP', 'WP/2', 'WNIP', 'WNOP'].includes(status)) {
                            weekOffCount += count;
                        } else if (['PH', 'PHP', 'PHNOP', 'PHNIP', 'PHP/2'].includes(status)) {
                            publicHolidayCount += count;
                        } else if (['OD'].includes(status)) {
                            outDoorCount += count;
                        } else if (['NOP', 'NIP'].includes(status)) {
                            notOutPunchCount += count;
                        } else if (status === 'A') {
                            absentCount += count;
                        }
                    }
                    totalDaysCount = presentCount + outDoorCount + weekOffCount + publicHolidayCount + notOutPunchCount
                    if (totalDaysCount === daysCount) {
                        payableDays = monthDays;
                    } else {
                        payableDays = monthDays - (daysCount - totalDaysCount)
                    }

                    // Calculate payableDays based on the month days and totalDaysCount
                    // if (totalDaysCount === monthDays - 1) {
                    //     payableDays = monthDays;
                    // } else {
                    //     payableDays = monthDays - (monthDays - 1 - totalDaysCount);
                    // }

                    empAttenResponseMap.set(empInfo.employeeId, new MonthAttnDataModel(
                        empInfo.employeeCode,
                        `${empInfo.employeeName} ${empInfo.employeeLastName}`,
                        deptNameMap.get(record.department_id),
                        empInfo.contractorName,
                        record.shift,
                        empInfo.workstationNumber,
                        [],
                        presentCount + outDoorCount,
                        absentCount,
                        workFromHomeCount,
                        leaveCount,
                        unitNameMap.get(empInfo.unitId),
                        undefined,
                        undefined,
                        weekOffCount,
                        publicHolidayCount,
                        notOutPunchCount,
                        totalDaysCount,
                        totalPresentDays,
                        payableDays,
                        record.weekOffDay
                    ));
                }


                empAttenResponseMap.get(empInfo.employeeId).dayStatus.push(new DayStatusModel(record.day, record.present_status, record.date));
            }
            const monthModelArray: MonthAttnDataModel[] = [];
            empAttenResponseMap.forEach(empAttn => monthModelArray.push(empAttn));
            if (monthModelArray) {
                return new MonthAttendanceResponse(true, 0, 'Retrieved successfully', monthModelArray);
            } else {
                return new MonthAttendanceResponse(false, 0, 'Error in getting data');
            }
        } catch (err) {
            return err;
        }
    }

    async attendanceUpload(formData: any): Promise<CommonResponse> {
        // console.log(formData, 'Received Form Data');
        const transactionManager = new GenericTransactionManager();
        const missingEmployeeCodes: string[] = [];
        try {
            const flag = new Set<boolean>();
            await transactionManager.startTransaction();
            const columnArray = [];
            const requiredColumns = ["EmployeeCode", "Date", "Shift", "InTime", "OutTime"];

            // console.log(formData, 'formdata');

            // Transform the data to the correct format
            const updatedArray = formData.map((obj) => {
                const updatedObj = {};

                const formattedDate = moment(obj.Date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                const formattedInTime = moment(obj['In Time'], 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss');
                const formattedOutTime = moment(obj['Out Time'], 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss');
                const calculateTotalHours = (inTime: string, outTime: string): string => {
                    const inTimeMoment = moment(inTime, 'YYYY-MM-DD HH:mm:ss');
                    const outTimeMoment = moment(outTime, 'YYYY-MM-DD HH:mm:ss');

                    if (!inTimeMoment.isValid() || !outTimeMoment.isValid()) {
                        return '00:00:00';
                    }

                    const diffInMillis = outTimeMoment.diff(inTimeMoment);
                    const duration = moment.duration(diffInMillis);

                    const diffInHours = Math.floor(duration.asHours());
                    const diffInMinutes = duration.minutes();
                    const diffInSeconds = duration.seconds();

                    return `${diffInHours.toString().padStart(2, '0')}:${diffInMinutes.toString().padStart(2, '0')}:${diffInSeconds.toString().padStart(2, '0')}`;
                };

                const totalHours = calculateTotalHours(formattedInTime, formattedOutTime);

                for (const key in obj) {
                    const newKey = key
                        .replace(/\s/g, '')
                        .replace(/[\(\)\.]/g, '')
                        .replace(/-/g, '');

                    if (newKey !== '') {
                        columnArray.push(newKey);
                        if (newKey === 'Date') {
                            updatedObj[newKey] = formattedDate;
                        } else if (newKey === 'InTime') {
                            updatedObj[newKey] = formattedInTime;
                        } else if (newKey === 'OutTime') {
                            updatedObj[newKey] = formattedOutTime;
                        } else if (newKey === 'Shift') {
                            const shiftValue = obj[key].toUpperCase();
                            if (!/^[A-EG]$/.test(shiftValue)) {
                                return new CommonResponse(false, 1112, `Invalid shift value: ${shiftValue}.`);
                            }
                            updatedObj[newKey] = shiftValue;
                        } else {
                            updatedObj[newKey] = obj[key];
                        }
                    }
                }

                // Add TotalHours to the updated object
                updatedObj['TotalHours'] = totalHours;

                return updatedObj;
            });

            // Check for missing columns
            for (const column of requiredColumns) {
                if (!columnArray.includes(column)) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1111, `${column} column is missing ☹️`);
                }
            }

            // Validate the format of Date, In Time, and Out Time
            for (const row of updatedArray) {
                const date = moment(row.Date, true);
                const inTime = moment(row.InTime, true);
                const outTime = moment(row.OutTime, true);

                // Check if the date and datetime values are valid
                if (!date.isValid()) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1112, `Invalid format for Date`);
                }

                if (!inTime.isValid()) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1113, `Invalid format for In Time`);
                }

                if (!outTime.isValid()) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1114, `Invalid format for Out Time`);
                }
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    updatedObj[key] = value === '' ? null : value;
                }
                return updatedObj;
            });

            // Validate each row
            for (const data of convertedData) {
                if (!data.EmployeeCode) {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 1112, 'Missing EmployeeCode in one of the rows');
                }
            }

            for (const data of convertedData) {
                if (data.EmployeeCode != null && data.Date != null) {
                    // Step 1: Update AttendanceEntity
                    const existedAttendance = await this.attendanceRepo.findOne({ where: { employeeCode: data.EmployeeCode, date: data.Date } });

                    if (existedAttendance) {
                        const updateAttendance = await transactionManager.getRepository(AttendanceEntity).update(
                            { attendaceId: existedAttendance.attendaceId },
                            { inTime: data.InTime, outTime: data.OutTime, shift: data.Shift }
                        );

                        if (updateAttendance.affected) {
                            // Step 2: Update or Insert ConsolidatedAttendanceLogEntity
                            let existingLog = await this.consolidatedAttendanceLogRepo.findOne({
                                where: { employeeCode: data.EmployeeCode, logDate: data.Date },
                            });

                            if (existingLog) {
                                // Clear specific columns before updating
                                const clearData = {
                                    inTime1: null,
                                    outTime1: null,
                                    inTime2: null,
                                    outTime2: null,
                                    inTime3: null,
                                    outTime3: null,
                                    inTime4: null,
                                    outTime4: null,
                                    inTime5: null,
                                    outTime5: null,
                                    inTime6: null,
                                    outTime6: null,
                                    shift: null,
                                    totalHours: null,
                                };

                                const clearResult = await transactionManager.getRepository(ConsolidatedAttendanceLogEntity)
                                    .update({ consolidatedLogId: existingLog.consolidatedLogId }, clearData);

                                if (clearResult.affected) {
                                    // Apply new updates after clearing
                                    const updateLog = {
                                        inTime1: data.InTime,
                                        outTime1: data.OutTime,
                                        shift: data.Shift,
                                        totalHours: data.TotalHours,
                                        manual: CartonShortageStatus.YES
                                    };

                                    const updateLogResult = await transactionManager.getRepository(ConsolidatedAttendanceLogEntity)
                                        .update({ consolidatedLogId: existingLog.consolidatedLogId }, updateLog);

                                    if (updateLogResult.affected) {
                                        flag.add(true);
                                    } else {
                                        flag.add(false);
                                        await transactionManager.releaseTransaction();
                                        return new CommonResponse(false, 0, 'Failed to update the consolidated log');
                                    }
                                } else {
                                    flag.add(false);
                                    await transactionManager.releaseTransaction();
                                    return new CommonResponse(false, 0, 'Failed to clear the consolidated log');
                                }
                            } else {
                                // Insert new record in ConsolidatedAttendanceLogEntity if no record is found
                                const insertLog = {
                                    employeeCode: data.EmployeeCode,
                                    logDate: data.Date,
                                    inTime1: data.InTime,
                                    outTime1: data.OutTime,
                                    shift: data.Shift,
                                    totalHours: data.TotalHours,
                                    manual: CartonShortageStatus.YES,
                                    employeeName: existedAttendance.employeeName
                                };

                                const insertLogResult = await transactionManager.getRepository(ConsolidatedAttendanceLogEntity)
                                    .insert(insertLog);

                                if (insertLogResult.identifiers.length > 0) {
                                    flag.add(true);
                                } else {
                                    flag.add(false);
                                    await transactionManager.releaseTransaction();
                                    return new CommonResponse(false, 0, 'Failed to insert the new consolidated log');
                                }
                            }
                        } else {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new CommonResponse(false, 0, 'Failed to update the attendance record');
                        }
                    } else {
                        // Track missing employee codes for attendance
                        missingEmployeeCodes.push(data.EmployeeCode);
                    }
                }
            }

            if (missingEmployeeCodes.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 1116, `${missingEmployeeCodes.join(', ')}, on ${formData.Date}`);
            }

            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new CommonResponse(true, 1, `Data updated successfully`);
            } else {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, `Error: ${err.message}`);
        }
    }

    async createEmpAttnLogForLastFourMonths(): Promise<AttendanceResponse> {
        try {
            const empCodes = [];
            const empDetails = await this.attendanceHelperService.getAllActiveEmployees();
            for (const empDetail of empDetails) {
                empCodes.push(empDetail.employeeCode);
            }
    
            const currentDate = new Date();
            const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 3, 1); // Four months back from the current month
            const endDate = currentDate; // Today's date
    
            const formatDate = (date: Date): string => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits for month
                const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits for day
                return `${year}-${month}-${day}`;
            };
    
            for (const empCode of empCodes) {
                const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
                if (!empInfo) {
                    continue; 
                }
    
                for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
                    const formattedDate = formatDate(date); // Use the helper function for consistent date formatting
    
                    // Check if attendance record already exists for this date and employee
                    const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(formattedDate, empCode);
                    
                    if (empRecord) {
                        console.log(`Skipping date ${formattedDate} for employee ${empCode} as record already exists.`);
                        continue;
                    }
    
                    let presentStatus = 'A'; // Default to 'A' (Absent)
    
                    // Check for holidays
                    try {
                        const holidays = await this.attendanceHelperService.getAllActiveHolidaysByNextDay(formattedDate);
                        if (holidays.length > 0) {
                            presentStatus = 'PH'; // Public Holiday
                        }
                    } catch (error) {
                        console.error('Error fetching holidays:', error);
                    }
    
                    // Check for week-off
                    try {
                        const weekOff = await this.attendanceHelperService.getWeekOffByEmpCode(empCode);
                        const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' }).toUpperCase(); // Get the current day as string (e.g., SUNDAY, MONDAY)
    
                        if (weekOff.some(wo => wo.weekOffDay === dayOfWeek)) {
                            presentStatus = 'WO'; // Mark as Week Off
                        }
    
                        if (empInfo.employeeType === 'Labour Form' && dayOfWeek === 'SUNDAY') {
                            presentStatus = 'WO'; // Sunday is always week off for 'Labour Form'
                        }
                    } catch (error) {
                        console.error('Error fetching week off:', error);
                    }
    
                    // Create attendance entry for the employee on the current date
                    const empAttnEnt = this.AttendanceAdapter.getAttendanceEntity(
                        empInfo.employeeId,
                        formattedDate,
                        null,
                        empCode,
                        `${empInfo.employeeName} ${empInfo.employeeLastName}`, // Concatenating first and last name
                        null,
                        null,
                        presentStatus,
                        null,
                        null,
                        null,
                        '',
                        Number(empInfo.departmentId),
                        null,
                        empInfo.designation,
                        empInfo.unitId,
                        date.getDate(), // Day
                        date.getMonth() + 1, // Month (0-based, so add 1)
                        date.getFullYear() // Year
                    );
    
                    const saveEntity = await this.attendanceRepo.save(empAttnEnt);
                    if (!saveEntity) {
                        return new AttendanceResponse(false, 1111, 'Something went wrong while creating logs');
                    }
                }
            }
    
            return new AttendanceResponse(true, 11101, 'Logs created successfully for the last four months');
        } catch (error) {
            return new AttendanceResponse(false, 500, 'Internal server error: ' + error.message);
        }
    }
    
    
}

